var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 930.984,
    height: 595.451,
    viewBox: "0 0 930.984 595.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.501,
    y1: 1,
    x2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_social_dashboard_k3pt",
    transform: "translate(-5.754 66.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4293",
    "data-name": "Path 4293",
    d: "M543.856,131.981c-48.2-1.676-94.1-17.233-137.937-34.257S318.667,61.836,271.593,52.817c-30.228-5.8-64.836-6.621-89.218,9.592-23.459,15.639-31.04,42.561-35.114,67.561-3.068,18.819-4.87,38.614,3.53,56.227,5.839,12.228,16.19,22.506,23.354,34.257,24.926,40.751,7.306,91-19.7,130.8-12.66,18.663-27.369,36.491-37.147,56.346s-14.3,42.635-5.742,62.9c8.475,20.108,28.679,35.181,50.567,45.8,44.452,21.552,96.814,27.726,147.909,31.219,113.071,7.738,226.738,4.386,340.107,1.035,41.958-1.244,84.094-2.5,125.367-8.989,22.923-3.6,46.582-9.324,63.219-23.087,21.128-17.523,26.363-47.2,12.206-69.17-23.742-36.856-89.367-46.016-105.981-85.569-9.13-21.768.246-46.024,13.524-66.213,28.478-43.32,76.207-81.316,78.717-130.833,1.728-34-21.217-68.06-56.7-84.154C743.315,63.668,691.743,65.791,664.322,93.71,636.06,122.4,586.417,133.456,543.856,131.981Z",
    transform: "translate(-101.281 -115.774)",
    fill: "#d8a251",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_status_update_jjgk",
    transform: "translate(103.857 15.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4410",
    "data-name": "Path 4410",
    d: "M959.445,683.025s-9.213-6.08-18.345-1.762c0,0,2.811,5.42,14.371,4.9Z",
    transform: "translate(-412.969 -270.006)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4411",
    "data-name": "Path 4411",
    d: "M965.04,684.56s2.8,10.675-4.221,17.94c0,0-4.228-4.4-.038-15.181Z",
    transform: "translate(-417.432 -271.219)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4412",
    "data-name": "Path 4412",
    d: "M975.336,668.659s-.682-9.079-21.186-6.072c0,0-.09,5.862,7.107,8.636S971.745,671.657,975.336,668.659Z",
    transform: "translate(-416.236 -265.566)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4413",
    "data-name": "Path 4413",
    d: "M982.083,670.81s8.666,2.781.937,22.01c0,0-5.712-1.274-6.747-8.929S978.327,673.591,982.083,670.81Z",
    transform: "translate(-421.723 -267.777)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4414",
    "data-name": "Path 4414",
    d: "M992.956,649.107s1.177-14.941-19.776-13.4c0,0-1.5,13.494,16.081,17Z",
    transform: "translate(-420.991 -258.961)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    d: "M813.743,156.582V545.229c0,11.552-11.148,20.991-24.912,20.991h-527.3c-13.764,0-24.912-9.4-24.912-20.991V156.582c0-11.575,11.148-23.382,24.912-23.382L788.8,134.482C802.565,134.482,813.743,145.045,813.743,156.582Z",
    transform: "translate(-236.62 -133.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    "data-name": "Path 4447",
    d: "M813.743,156.7v17.992H236.62V156.7a23.5,23.5,0,0,1,23.525-23.5h530.1A23.5,23.5,0,0,1,813.743,156.7Z",
    transform: "translate(-236.62 -133.2)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 8.306,
    cy: 8.306,
    r: 8.306,
    transform: "translate(19.657 12.437)",
    fill: "#fa5959",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 8.306,
    cy: 8.306,
    r: 8.306,
    transform: "translate(43.819 12.437)",
    fill: "#fed253",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 8.306,
    cy: 8.306,
    r: 8.306,
    transform: "translate(67.981 12.437)",
    fill: "#8ccf4d",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(218.65 139.762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    d: "M785.461,322.156v41.982c0,1.252-4.977,2.249-11.132,2.249H539.412c-6.139,0-11.132-1.012-11.132-2.249V322.156c0-1.252,4.962-2.526,11.132-2.526H774.329C780.5,319.623,785.461,320.9,785.461,322.156Z",
    transform: "translate(-528.28 -319.63)",
    fill: "#46b585"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_676",
    "data-name": "Rectangle 676",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.452 151.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    "data-name": "Path 4449",
    d: "M555.764,333.66a13.682,13.682,0,0,0-7.542,25.092v-.907a3.111,3.111,0,0,1,2.736-3.081,5.428,5.428,0,0,0,9.521,0,3.111,3.111,0,0,1,2.736,3.081v.967a13.682,13.682,0,0,0-7.452-25.152Zm5.368,17.347a5.42,5.42,0,0,1-10.818,0,5.937,5.937,0,0,1,3.111-7.954,1.844,1.844,0,0,1-.292-.982,1.807,1.807,0,0,1,1.814-1.807h.127a1.807,1.807,0,0,0-1.679,1.8,1.829,1.829,0,0,0,.24.9h.052a1.958,1.958,0,0,1,0-.36,1.762,1.762,0,0,1,.345-1.05,1.8,1.8,0,0,1,1.724-1.274h.127a1.792,1.792,0,0,0-1.379.81,1.754,1.754,0,0,1,1-.3,1.807,1.807,0,0,1,1.807,1.807,1.836,1.836,0,0,1,0,.2,5.945,5.945,0,0,1,4.408,5.742A6.05,6.05,0,0,1,561.132,351.008Z",
    transform: "translate(-522.413 -280.409)",
    fill: "#1f3356",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_677",
    "data-name": "Rectangle 677",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.452 156.263)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_678",
    "data-name": "Rectangle 678",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.452 161.226)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_679",
    "data-name": "Rectangle 679",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.452 166.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(218.792 205.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    d: "M611.909,431.826v41.982c0,1.244-4.959,2.249-11.126,2.249H366c-6.135,0-11.126-1.02-11.126-2.249V431.826c0-1.252,4.959-2.526,11.126-2.526H600.815C606.95,429.3,611.909,430.575,611.909,431.826Z",
    transform: "translate(-354.87 -429.3)",
    fill: "#46b585"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.444 216.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_681",
    "data-name": "Rectangle 681",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.444 221.741)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.444 226.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_683",
    "data-name": "Rectangle 683",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.444 231.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(218.833 83.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4452",
    "data-name": "Path 4452",
    d: "M572.166,254.236v41.982c0,1.244-4.962,2.249-11.133,2.249h-234.9c-6.123,0-11.133-1.02-11.133-2.249V254.236c0-1.252,4.978-2.526,11.133-2.526H561.065C567.2,251.71,572.166,252.984,572.166,254.236Z",
    transform: "translate(-315 -251.71)",
    fill: "#46b585"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 118.63,
    height: 2.039,
    transform: "translate(225.732 70.345)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_724",
    "data-name": "Rectangle 724",
    width: 118.63,
    height: 2.039,
    transform: "translate(225.732 59.017)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_685",
    "data-name": "Rectangle 685",
    width: 118.63,
    height: 2.039,
    transform: "translate(225.732 75.308)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_725",
    "data-name": "Rectangle 725",
    width: 118.63,
    height: 2.039,
    transform: "translate(225.732 63.98)",
    fill: "#5b5b5b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_686",
    "data-name": "Rectangle 686",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.612 95.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_687",
    "data-name": "Rectangle 687",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.612 100.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_726",
    "data-name": "Rectangle 726",
    width: 57.754,
    height: 2.039,
    transform: "translate(241 109.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_727",
    "data-name": "Rectangle 727",
    width: 57.754,
    height: 2.039,
    transform: "translate(241 115.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_728",
    "data-name": "Rectangle 728",
    width: 57.754,
    height: 2.039,
    transform: "translate(241 121.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(218.863 261.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M825.828,519.159v41.982c0,1.252-4.961,2.249-11.132,2.249H579.772c-6.138,0-11.132-1.012-11.132-2.249V519.159c0-1.252,4.962-2.519,11.132-2.519H814.729C820.867,516.6,825.828,517.869,825.828,519.159Z",
    transform: "translate(-568.64 -516.639)",
    fill: "#46b585"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_688",
    "data-name": "Rectangle 688",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.665 273.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.665 278.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_690",
    "data-name": "Rectangle 690",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.665 283.278)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_691",
    "data-name": "Rectangle 691",
    width: 191.23,
    height: 2.039,
    transform: "translate(233.665 288.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(18.833 89.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4550",
    "data-name": "Path 4550",
    d: "M180.373,316.694V568.521c0,7.51-2.81,13.491-6.284,13.491l-137.862.251c-3.465,0-1.043-6.321-1.043-13.741V316.694c0-7.51-1.253-15.355,2.23-15.355l140.131.132C181,301.471,180.373,309.185,180.373,316.694Z",
    transform: "translate(-34.361 -301.339)",
    fill: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_700",
    "data-name": "Rectangle 700",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 29.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 118.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_701",
    "data-name": "Rectangle 701",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 52.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 140.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_702",
    "data-name": "Rectangle 702",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 74.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_705",
    "data-name": "Rectangle 705",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 163.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_703",
    "data-name": "Rectangle 703",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 96.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_704",
    "data-name": "Rectangle 704",
    width: 109.517,
    height: 16.815,
    transform: "translate(15.927 185.231)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_708",
    "data-name": "Rectangle 708",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 56.918)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_710",
    "data-name": "Rectangle 710",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 34.754)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_712",
    "data-name": "Rectangle 712",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 79.082)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_714",
    "data-name": "Rectangle 714",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 101.246)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_716",
    "data-name": "Rectangle 716",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 123.41)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_718",
    "data-name": "Rectangle 718",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 145.574)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_720",
    "data-name": "Rectangle 720",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 167.738)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_722",
    "data-name": "Rectangle 722",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 189.902)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_709",
    "data-name": "Rectangle 709",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 61.881)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_711",
    "data-name": "Rectangle 711",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 39.717)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 84.045)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_715",
    "data-name": "Rectangle 715",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 106.209)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_717",
    "data-name": "Rectangle 717",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 128.373)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_719",
    "data-name": "Rectangle 719",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 150.537)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_721",
    "data-name": "Rectangle 721",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 172.701)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_723",
    "data-name": "Rectangle 723",
    width: 57.695,
    height: 2.039,
    transform: "translate(26.139 194.865)",
    fill: "#5d5d5d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 2.955,
    cy: 2.955,
    r: 2.955,
    transform: "translate(233.36 107.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 2.955,
    cy: 2.955,
    r: 2.955,
    transform: "translate(233.36 113.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 2.955,
    cy: 2.955,
    r: 2.955,
    transform: "translate(233.36 120.178)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 141.594,
    cy: 14.431,
    rx: 141.594,
    ry: 14.431,
    transform: "translate(30.576 459.332)",
    fill: "#46b585",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 66.332,
    cy: 6.762,
    rx: 66.332,
    ry: 6.762,
    transform: "translate(420.676 515.171)",
    fill: "#4c99e6",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 66.332,
    cy: 6.762,
    rx: 66.332,
    ry: 6.762,
    transform: "translate(647.33 481.099)",
    fill: "#4c99e6",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4295",
    "data-name": "Path 4295",
    d: "M841.545,134.692s-55.105-3.325-48.607,35.288c0,0-1.309,6.826,4.9,9.922,0,0,.1-2.86,5.648-1.891a25.156,25.156,0,0,0,5.988.288,12.435,12.435,0,0,0,7.323-3.017h0s15.485-6.4,21.512-31.715c0,0,4.457-5.524,4.28-6.944l-9.3,3.973s3.174,6.708.654,12.284c0,0-.3-12.042-2.088-11.78-.366.052-4.836,2.323-4.836,2.323s5.471,11.682,1.309,20.177c0,0,1.564-14.4-3.05-19.333l-6.545,3.822s6.387,12.068,2.062,21.918c0,0,1.106-15.1-3.436-20.988l-5.929,4.627s6,11.891,2.343,20.059c0,0-.484-17.579-3.632-18.907,0,0-5.19,4.581-5.982,6.453,0,0,4.11,8.639,1.564,13.194,0,0-1.564-11.715-2.847-11.78,0,0-5.17,7.762-5.707,13.089,0,0,.222-7.912,4.45-13.822,0,0-4.993.857-7.912,4.1,0,0,.805-5.484,9.162-5.969,0,0,4.274-5.89,5.419-6.244,0,0-8.344-.7-13.4,1.545,0,0,4.45-5.177,14.935-2.821l5.851-4.784s-10.982-1.5-15.642.157c0,0,5.367-4.581,17.225-1.243l6.374-3.809s-9.365-2.022-14.948-1.309c0,0,5.89-3.174,16.813.268l4.581-2.048s-6.865-1.348-8.875-1.564-2.114-.766-2.114-.766a23.79,23.79,0,0,1,12.978,1.479S841.709,135.3,841.545,134.692Z",
    transform: "translate(-430.552 -157.548)",
    fill: "#d8a251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4296",
    "data-name": "Path 4296",
    d: "M771.228,108.476s-26.907-1.621-23.763,17.256a4.6,4.6,0,0,0,2.393,4.85s.05-1.416,2.762-.928a12.4,12.4,0,0,0,2.924.142,6.1,6.1,0,0,0,3.583-1.473h0s7.569-3.13,10.515-15.507c0,0,2.181-2.7,2.124-3.392l-4.546,1.94s1.551,3.278.326,6c0,0-.142-5.884-1.02-5.75-.177,0-2.358,1.14-2.358,1.14s2.669,5.707.651,9.863c0,0,.765-7.038-1.487-9.453l-3.2,1.869s3.123,5.9,1.005,10.713c0,0,.545-7.385-1.678-10.26l-2.9,2.266s2.939,5.813,1.147,9.807c0,0-.234-8.6-1.77-9.247,0,0-2.542,2.238-2.924,3.158,0,0,2,4.248.758,6.451,0,0-.765-5.728-1.416-5.757,0,0-2.528,3.8-2.79,6.373a13.78,13.78,0,0,1,2.174-6.755,7.583,7.583,0,0,0-3.866,2s.389-2.684,4.489-2.917c0,0,2.089-2.882,2.648-3.059,0,0-4.078-.34-6.55.758,0,0,2.174-2.528,7.3-1.416l2.832-2.337s-5.367-.708-7.647.078c0,0,2.627-2.238,8.419-.609l3.116-1.862a28.3,28.3,0,0,0-7.3-.63s2.875-1.551,8.214.127l2.23-1s-3.349-.659-4.333-.765-1.034-.375-1.034-.375a11.584,11.584,0,0,1,6.295.708S771.305,108.773,771.228,108.476Z",
    transform: "translate(-251.166 -108.358)",
    fill: "#4c99e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4298",
    "data-name": "Path 4298",
    d: "M895.971,632.54s13.6,17.8-6.291,44.664-36.282,49.539-29.645,66.288c0,0,30.007-49.885,54.43-50.593S922.833,662.547,895.971,632.54Z",
    transform: "translate(-7.894 -288.825)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4299",
    "data-name": "Path 4299",
    d: "M894.426,632.54a21.638,21.638,0,0,1,2.688,5.391c23.005,27.029,35.259,52.266,13.135,52.889-20.591.592-45.312,37.431-51.219,46.724a17.377,17.377,0,0,0,.7,2.126S888.7,691.5,912.283,690.82,920.362,661.513,894.426,632.54Z",
    transform: "translate(-9.544 -283.243)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4300",
    "data-name": "Path 4300",
    d: "M899.565,648.461c0,6.291-.708,11.339-1.573,11.339s-1.573-5.08-1.573-11.339.881-3.3,1.746-3.3S899.565,642.17,899.565,648.461Z",
    transform: "translate(13.801 -282.005)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4301",
    "data-name": "Path 4301",
    d: "M907.851,653.286c-5.5,2.988-10.285,4.812-10.71,4.042s3.711-3.806,9.216-6.81,3.318-.8,3.743,0S913.355,650.282,907.851,653.286Z",
    transform: "translate(14.197 -279.407)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4302",
    "data-name": "Path 4302",
    d: "M847.756,632.54s-13.6,17.8,6.291,44.664,36.281,49.539,29.66,66.288c0,0-30.007-49.885-54.43-50.593S820.894,662.547,847.756,632.54Z",
    transform: "translate(-31.549 -288.825)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4303",
    "data-name": "Path 4303",
    d: "M846.708,632.54a21.023,21.023,0,0,0-2.688,5.391c-23.005,27.029-35.259,52.267-13.15,52.889,20.606.592,45.312,37.431,51.234,46.724a20.489,20.489,0,0,1-.7,2.126S852.432,691.5,828.85,690.82,820.772,661.513,846.708,632.54Z",
    transform: "translate(-31.221 -283.243)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4304",
    "data-name": "Path 4304",
    d: "M820.55,648.461c0,6.291.708,11.339,1.573,11.339s1.573-5.08,1.573-11.339-.881-3.3-1.746-3.3S820.55,642.17,820.55,648.461Z",
    transform: "translate(-29.648 -282.005)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4305",
    "data-name": "Path 4305",
    d: "M816.21,653.286c5.489,2.988,10.285,4.812,10.694,4.042s-3.7-3.806-9.2-6.81-3.334-.8-3.743,0S810.769,650.282,816.21,653.286Z",
    transform: "translate(-34.036 -279.407)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4306",
    "data-name": "Path 4306",
    d: "M823.31,709.1s38.043-1.18,49.508-9.342,58.519-17.913,61.334-4.812,57.167,65.124,14.154,65.47-99.8-6.7-111.235-13.667S823.31,709.1,823.31,709.1Z",
    transform: "translate(-28.067 -256.758)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    "data-name": "Path 4307",
    d: "M944.835,746.77c-41.47.334-96.363-6.469-107.4-13.2-8.428-5.117-11.768-23.506-12.892-31.995h-1.23s2.323,29.626,13.378,36.353,65.933,13.53,107.4,13.2c11.966-.106,16.111-4.358,15.883-10.629C958.3,744.31,953.748,746.694,944.835,746.77Z",
    transform: "translate(-28.065 -247.446)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_671",
    "data-name": "Rectangle 671",
    width: 257.797,
    height: 55.251,
    transform: "matrix(0.742, -0.671, 0.671, 0.742, 334.615, 398.516)",
    fill: "#62dca7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4308",
    "data-name": "Path 4308",
    d: "M1023.029,778.486c3.215.418,6.55.708,9.63-.326.474-.149,1.02-.474.956-.963a1.135,1.135,0,0,0-.219-.467,30.035,30.035,0,0,1-2.924-5.544.453.453,0,0,0-.177-.248.431.431,0,0,0-.312,0c-1.416.368-2.648,1.289-4.064,1.678a5.8,5.8,0,0,1-2.209.17c-.637-.071-1.515-.6-2.089-.538C1021.974,774.351,1022.781,776.341,1023.029,778.486Z",
    transform: "translate(-331.274 -301.749)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    "data-name": "Path 4309",
    d: "M1108.086,769.463c2.124-1.416,4.319-2.988,5.573-5.233a.857.857,0,0,0,.149-.446.921.921,0,0,0-.177-.439,18.139,18.139,0,0,0-4.525-4.886,13.372,13.372,0,0,0-2.528,2.33c-.531.559-2,1.48-2.018,2.315,0,.5.559,1.048.821,1.416.354.524.708,1.062,1.013,1.6A26.552,26.552,0,0,1,1108.086,769.463Z",
    transform: "translate(-355.486 -298.115)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4310",
    "data-name": "Path 4310",
    d: "M1027.877,786.389a2.124,2.124,0,0,1-.382,1.416,1.892,1.892,0,0,1-.814.474c-4.5,1.607-9.686-.4-14.161,1.19-.928.326-1.8.793-2.726,1.1a14.756,14.756,0,0,1-3.377.6c-1.593.156-3.186.248-4.78.29a11.557,11.557,0,0,1-3.6-.312,4.354,4.354,0,0,1-2.762-2.188,2.124,2.124,0,0,1-.135-1.558,1.761,1.761,0,0,1,.29-.5,4.31,4.31,0,0,1,1.062-.857l1.657-1.069a11.067,11.067,0,0,1,2.506-1.331c.651-.212,1.352-.3,2.011-.5,2.33-.708,4.1-2.528,5.75-4.3l2.252-2.4a2.2,2.2,0,0,1,.779-.623,2.125,2.125,0,0,1,.963-.1,13.008,13.008,0,0,1,6.139,2.068,8.858,8.858,0,0,0,1.515.892,5.41,5.41,0,0,0,4.248-.531c.58-.3.453-.5.708-1.041s.836-.9,1.345-.4a1.478,1.478,0,0,1,.319.609,16.9,16.9,0,0,1,.3,5.006,2.22,2.22,0,0,0,.1.779,4.762,4.762,0,0,0,.439.708,1.1,1.1,0,0,1,.092.184,4.915,4.915,0,0,1,.255,2.379Z",
    transform: "translate(-323.519 -303.152)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    "data-name": "Path 4311",
    d: "M1027.877,789.812a2.124,2.124,0,0,1-.382,1.416,1.891,1.891,0,0,1-.814.474c-4.5,1.607-9.686-.4-14.161,1.19-.928.326-1.8.793-2.726,1.1a14.766,14.766,0,0,1-3.377.6c-1.593.156-3.186.248-4.78.29a11.557,11.557,0,0,1-3.6-.312,4.355,4.355,0,0,1-2.762-2.188,2.124,2.124,0,0,1-.135-1.558,1.761,1.761,0,0,1,.29-.5c.269.552.46,1.274.623,1.537a3.144,3.144,0,0,0,2.124,1.522,5.389,5.389,0,0,0,1.919-.248c4.079-1.013,8.412-1.027,12.321-2.556a29.437,29.437,0,0,1,4.036-1.551,32.075,32.075,0,0,1,4.362-.354c2.3-.184,4.525-.878,6.8-1.239a4.915,4.915,0,0,1,.262,2.372Z",
    transform: "translate(-323.519 -306.575)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    "data-name": "Path 4312",
    d: "M1113.568,770.382a8.171,8.171,0,0,1-2.485,4.425,28.379,28.379,0,0,0-3.469,3.8c-1.176,1.784-1.693,3.986-3.208,5.495a8.692,8.692,0,0,1-1.926,1.416,13.318,13.318,0,0,1-2.5,1.147,19.131,19.131,0,0,1-7.081.389,6.293,6.293,0,0,1-2.238-.439,6.5,6.5,0,0,1-.949-.574,4.5,4.5,0,0,1-1.417-1.466,1.472,1.472,0,0,1-.134-1.055,2.4,2.4,0,0,1,.708-1.034,15.983,15.983,0,0,1,1.706-1.537A10.125,10.125,0,0,0,1092.8,779a6.38,6.38,0,0,0,.857-1.954,17.528,17.528,0,0,0,.623-3.717,11.7,11.7,0,0,1,.262-2.485c.361-1.275,1.31-2.429,1.2-3.753a.961.961,0,0,1,.049-.566.886.886,0,0,1,.446-.276,8.071,8.071,0,0,1,2.322-.531,2.677,2.677,0,0,1,2.124.843c.333.4.545.949,1.034,1.126a1.714,1.714,0,0,0,.708,0,6.023,6.023,0,0,0,3.371-1.041,4.249,4.249,0,0,0,1.416-3.094c0-.439-.2-.9.474-.991.517-.071.92.467,1.182.821a11.557,11.557,0,0,1,2.273,4.142,1.148,1.148,0,0,1,.432-.085,1.848,1.848,0,0,1,1.544.793,3.059,3.059,0,0,1,.453,2.153Z",
    transform: "translate(-350.687 -299.309)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4313",
    "data-name": "Path 4313",
    d: "M1113.641,772.413a8.172,8.172,0,0,1-2.485,4.425,28.367,28.367,0,0,0-3.469,3.8c-1.176,1.784-1.693,3.986-3.208,5.495a8.687,8.687,0,0,1-1.926,1.416,13.321,13.321,0,0,1-2.5,1.147,19.134,19.134,0,0,1-7.081.389,6.3,6.3,0,0,1-2.237-.439,6.5,6.5,0,0,1-.949-.574,4.5,4.5,0,0,1-1.416-1.466,3.449,3.449,0,0,1,1.459-.347c1.055.057,1.82,1.048,2.832,1.352,1.416.432,2.832-.581,4.312-.928.949-.22,1.954-.156,2.882-.46a7.118,7.118,0,0,0,2.124-1.289,10.785,10.785,0,0,0,2.273-2.2,13.99,13.99,0,0,0,1.338-2.662,38.024,38.024,0,0,1,2.7-5.162,3.421,3.421,0,0,1,.552-.708c.219-.205.5-.354.708-.538a5.633,5.633,0,0,0,1.714-3.123,5.224,5.224,0,0,1,.382-1.041,1.848,1.848,0,0,1,1.544.793A3.058,3.058,0,0,1,1113.641,772.413Z",
    transform: "translate(-350.76 -301.341)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4314",
    "data-name": "Path 4314",
    d: "M979.617,555.043a10.281,10.281,0,0,1,2.889,3.378c.708,1.331,4.6,11.669,4.369,13.149,1.275-1.289,6.33-1.5,7.6-2.783.538-.538,3.448-3.229,3.88-3.852s3.675-1.961,4.029-2.6c1.324-2.372-9.389-11.329-8.023-13.708a.581.581,0,0,0,.113-.368.567.567,0,0,0-.177-.283,17.04,17.04,0,0,0-3.1-2.124,4.957,4.957,0,0,1-2.365-2.832,10.176,10.176,0,0,0-2.74,1.855q-2.939,2.513-5.792,5.155c-.751.708-2.181,1.607-2.528,2.592S978.9,554.462,979.617,555.043Z",
    transform: "translate(-318.457 -235.223)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    "data-name": "Path 4315",
    d: "M999.32,554.61a31.033,31.033,0,0,0-4.588,3.753,9.182,9.182,0,0,0-2.924,4.68c-.135.708-.113,1.459-.227,2.188-.474,3.172-3.229,5.5-4.44,8.5a14.536,14.536,0,0,0-.779,2.832,33.39,33.39,0,0,0-.552,5.565c0,1.813,1.742,3.059,2.393,4.751a28.831,28.831,0,0,1,1.154,5.148,62.71,62.71,0,0,0,2.9,9.559c2.393,6.606,10.147,24.875,12.54,31.488,7.329-1.841,26.843-6.068,33.329-9.913,2.167-1.289-15.011-15.847-12.7-16.852a1.168,1.168,0,0,0,.644-.489,1.118,1.118,0,0,0,0-.708c-2.308-10.118-9.552-18.41-12.83-28.323-1.14-3.42-3.186-6.337-4.744-9.594-1.416-2.946-2.16-6.2-3.838-8.993a6.015,6.015,0,0,0-1.225-1.536,7.515,7.515,0,0,0-1.359-.814C1001.147,555.353,1000.255,555.077,999.32,554.61Z",
    transform: "translate(-320.82 -238.606)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 11.471,
    cy: 11.471,
    r: 11.471,
    transform: "translate(650.078 295.725)",
    fill: "#ffcdd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    "data-name": "Path 4316",
    d: "M997.43,549.361a3.845,3.845,0,0,1,4.312-.616,2.124,2.124,0,0,1,1.282,2.068l5.665.085a11.855,11.855,0,0,1,2.7.248,3.923,3.923,0,0,1,2.252,1.416c.071.092.149.2.262.219a.453.453,0,0,0,.262-.092,4.993,4.993,0,0,1,2.832-.51,15.309,15.309,0,0,1,8.327,3.661,2.7,2.7,0,0,1,.991,1.211c.2.644,0,1.473.467,1.912,0,5.346,1.834,10.324,3.059,15.528a6.881,6.881,0,0,0,1.721,2.471,9.914,9.914,0,0,1,1.841,2.747c1.034,2.7-.4,5.863.616,8.575a13.807,13.807,0,0,0,1.954,3.08,7.938,7.938,0,0,1,1.664,3.979c.042.651-.042,1.3,0,1.961a11.953,11.953,0,0,0,.467,2.577c.411,1.565.85,3.13,1.3,4.687.708,2.521,1.7,5.247,3.958,6.592-5.459.927-11.209,1.827-16.413-.064a8.5,8.5,0,0,1-2.047-1.027c-1.876-1.338-2.783-3.633-3.59-5.792a27.222,27.222,0,0,1-2.011-7.477,8.556,8.556,0,0,0-.34-2.443c-.531-1.416-1.933-2.259-3.222-3.038a15.5,15.5,0,0,1-3.873-3.016,6.018,6.018,0,0,1-1.572-4.532c.1-.8.411-1.572.446-2.379a1.9,1.9,0,0,0-1.1-1.961c-3.972-1.2-5.87-5.905-6.755-9.963a31.789,31.789,0,0,1-.51-6.373l-.05-4.1a5.438,5.438,0,0,1-1.784-3.923,4.4,4.4,0,0,0,0-1.3,3.631,3.631,0,0,0-.906-1.416,11.964,11.964,0,0,1-2.2-3Z",
    transform: "translate(-324.212 -236.777)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4317",
    "data-name": "Path 4317",
    d: "M979.841,566.894a30.3,30.3,0,0,1-.127,3.852c-.113.482-.3.942-.446,1.416a8.356,8.356,0,0,0,.531,5.4,30,30,0,0,0,2.754,4.779,7.281,7.281,0,0,1,.885,1.65,8.541,8.541,0,0,1,.34,1.89,57.577,57.577,0,0,0,1.352,7.6,14.939,14.939,0,0,0,2.677,6.111,1.855,1.855,0,0,0,1.1.751,2,2,0,0,0,.942-.2l2.932-1.112a2.049,2.049,0,0,0,.708-.368,1.777,1.777,0,0,0,.411-1.147,16.856,16.856,0,0,0-1.289-6.946c-2.379-6.755-5.537-13.262-7.081-20.251-.432-1.954-.659-4.957-2.082-6.479-.588-.637-.389-.368-1.09,0a8.884,8.884,0,0,0-1.027.545,3.363,3.363,0,0,0-1.494,2.507Z",
    transform: "translate(-318.845 -241.189)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4318",
    "data-name": "Path 4318",
    d: "M1059.24,627.68",
    transform: "translate(-342.256 -259.937)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4319",
    "data-name": "Path 4319",
    d: "M992.358,578.216q1.168,6.181,2.386,12.37l11.386-2.988a7.976,7.976,0,0,0-.984-3.406c-1.041-2.606-1.062-5.5-1.9-8.178-.637-2.039-1.742-3.916-2.337-5.969-.347-1.19-.517-2.436-.857-3.632a27.742,27.742,0,0,0-1.338-3.462,22.06,22.06,0,0,0-2.485-4.61c-1.459.545-3.009,1.175-3.838,2.485a5.283,5.283,0,0,0-.708,2.45c-.2,2.563.708,5.134.418,7.669a22.659,22.659,0,0,0,.262,7.272Z",
    transform: "translate(-322.525 -239.695)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4320",
    "data-name": "Path 4320",
    d: "M1009.761,653.884c.637,2.436-.29,4.957-1.041,7.378a57.3,57.3,0,0,0-2.323,11.11,9.2,9.2,0,0,1-.573,2.832,26.445,26.445,0,0,1-1.381,2.266c-1.147,2.025-1.119,4.5-.871,6.819.163,1.53.411,3.052.708,4.56.375,1.834.836,3.76.3,5.551.9-.2,1.515.963,1.48,1.891s-.361,1.919.078,2.733c1.119.4,1.133,1.94,1.1,3.123a26.332,26.332,0,0,0,.772,6.118q2.535,12.172,5.381,24.28c4.1,1.274,8.886,2.6,12.795.836a2.514,2.514,0,0,0,1.621-1.629,2.933,2.933,0,0,0-.156-1.253l-1.855-6.741a12.411,12.411,0,0,1-.665-4.956c.184-1.253.708-2.6.113-3.7a10.645,10.645,0,0,0-.779-1.034c-.977-1.416-.467-3.321-.382-5.049a3.951,3.951,0,0,0-.085-1.154,6.058,6.058,0,0,0-.545-1.267,19.352,19.352,0,0,1-2.124-9.63,2.367,2.367,0,0,0-.17-1.26,2.878,2.878,0,0,1-.311-.51,1.366,1.366,0,0,1,.1-.927,8.062,8.062,0,0,1-1.494-1.416,2.124,2.124,0,0,0,.354-3.271,1.091,1.091,0,0,0,.524-1.877c-.241-.17-.552-.241-.708-.481-.262-.354-.05-.857.163-1.239l1.133-2.046c.842-1.515,1.034-3.392,1.94-4.872a36.562,36.562,0,0,0,2.988-6.819l3.229-8.992,2.2,1.9a6.875,6.875,0,0,1,1.806,2.061,8.688,8.688,0,0,1,.581,2.464c.807,4.886,3.887,9.12,5.027,13.942a9.4,9.4,0,0,0,1.034,3.115,6.761,6.761,0,0,1,.595.892,4.7,4.7,0,0,1,.248,1.48,6.9,6.9,0,0,0,2.91,4.957c1.076.708,2.443,1.253,3.009,2.429a4.8,4.8,0,0,0,.5,1.034c.524.63,1.657.708,1.883,1.494.12.446-.113.97.142,1.359a1.238,1.238,0,0,0,.531.4l3.165,1.586c3.54,1.763,5.325,5.806,7.937,8.773A18.215,18.215,0,0,1,1063,714.29c1.126,2.011,1.65,4.539,3.54,5.835a5.5,5.5,0,0,1,1.374,1.02c.6.786.382,1.891.432,2.882s.814,2.167,1.756,1.869a6.837,6.837,0,0,0,0,3.661,18.452,18.452,0,0,0,11.188-4.532,4.414,4.414,0,0,0,1.82-3.052,1.182,1.182,0,0,0-.134-.609,1.657,1.657,0,0,0-.708-.538c-2.953-1.6-3.845-5.31-5.325-8.327-1.31-2.655-3.236-4.957-4.871-7.421-3.54-5.311-5.905-11.733-11.223-15.245-1.168-.772-2.528-1.459-3.108-2.733a21.808,21.808,0,0,1-.623-2.266,1.9,1.9,0,0,0-1.664-1.416,10.107,10.107,0,0,0,.382-3.54,4.406,4.406,0,0,0-.177-1.522,7.188,7.188,0,0,0-.779-1.5,14.552,14.552,0,0,1-2-7.789,12.541,12.541,0,0,0-.135-4.185c-.212-.708-.581-1.3-.843-1.954a12.184,12.184,0,0,1-.609-3.647l-.29-4.666a22.335,22.335,0,0,0-.6-4.61c-.984-3.618-1.926-18.778-5.261-20.485s-9.028,9.956-12.745,10.189a17,17,0,0,0-4.871.935,23.609,23.609,0,0,0-6.606,4.383l-6.883,5.778A25.091,25.091,0,0,1,1009.761,653.884Z",
    transform: "translate(-325.965 -260.424)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4321",
    "data-name": "Path 4321",
    d: "M964.518,522.837a8.652,8.652,0,0,1,6.677-3.257,15.579,15.579,0,0,1,7.378,1.855,9.508,9.508,0,0,0,2.124.885c1.218.248,2.563-.085,3.661.5,1.459.772,1.735,2.74,1.607,4.383s-.432,3.441.439,4.85a13.466,13.466,0,0,1,.843,1.26,4.205,4.205,0,0,1-.078,2.7,21.672,21.672,0,0,1-1.416-1.777,1.648,1.648,0,0,0-2-.524c-.623.418-.623,1.19-.651,1.876s-.212,1.515-.864,1.742a1.416,1.416,0,0,1-1.416-.566c-1.112-1.36-.666-3.54-1.763-4.9-.63-.779-1.671-1.154-2.252-1.968-.453-.637-.566-1.466-.963-2.124s-1.324-1.2-1.947-.708a2.647,2.647,0,0,0-.517.708,2.981,2.981,0,0,1-3.54,1.062,6.211,6.211,0,0,0-1.537-.659,1.891,1.891,0,0,0-1.749.949,3.767,3.767,0,0,0-.46,2.025,4.709,4.709,0,0,1-.382,2.783,2.878,2.878,0,0,1-.821.708,2.431,2.431,0,0,1-2.691.276,2.025,2.025,0,0,1-.6-1.883,15.48,15.48,0,0,1,.574-1.99c.425-1.5-.127-3.193.34-4.61A14.506,14.506,0,0,1,964.518,522.837Z",
    transform: "translate(-313.739 -228.38)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4322",
    "data-name": "Path 4322",
    d: "M974.4,564a1.771,1.771,0,0,0,.106,1.055,1.713,1.713,0,0,0,.573.552,11.883,11.883,0,0,0,5.41,1.749,1.628,1.628,0,0,1,.708.191,1.338,1.338,0,0,1,.319,1.508,4.014,4.014,0,0,0-.34,1.6c.142,1.013,1.338,1.473,2.358,1.6a5.467,5.467,0,0,0,4.1-.793,6.323,6.323,0,0,0,1.692-2.542c2.783-6.373,3.76-13.453,6.578-19.826a4.029,4.029,0,0,0,.425-1.324,1.317,1.317,0,0,0-.524-1.225c-.524-.326-1.338-.142-1.692-.644-.177-.262-.156-.609-.312-.878-.326-.581-1.175-.51-1.763-.821-.453-.248-.772-.708-1.274-.843a1.629,1.629,0,0,0-1.331.573c-1.65,1.544-2.521,3.732-3.441,5.8a68.888,68.888,0,0,1-4.956,9.141c.22-.34-1.048-2.924-1.544-3.024-.864-.177-1.983,1.345-2.45,1.919A12.151,12.151,0,0,0,974.4,564Z",
    transform: "translate(-317.48 -235.321)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 197.33,
    height: 55.251,
    transform: "translate(581.476 337.742)",
    fill: "#46b585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4323",
    "data-name": "Path 4323",
    d: "M1058.423,627.139a22.318,22.318,0,0,0-2.62,2.747,5.472,5.472,0,0,0-1.2,3.54,1.82,1.82,0,0,0,.34,1.034.885.885,0,0,0,.984.3,1.418,1.418,0,0,0,.482-.432,22.669,22.669,0,0,1,1.629-1.77c.213-.205.482-.425.765-.347a.806.806,0,0,1,.333.219,2.253,2.253,0,0,1,.708,1.069,2.534,2.534,0,0,1-.75,2.061,5.343,5.343,0,0,0-1.268,1.876.8.8,0,0,0,0,.6.985.985,0,0,0,.375.326,5.466,5.466,0,0,0,4.581.3c.984-.389,1.834-1.069,2.832-1.416a6.806,6.806,0,0,0,1.253-.467,2.578,2.578,0,0,0,1.112-1.657,7.084,7.084,0,0,0,.078-2.046,23.366,23.366,0,0,0-1.706-7.718.922.922,0,0,0-.276-.411.97.97,0,0,0-.467-.135c-1.239-.127-3.278-.765-4.475-.3a3.059,3.059,0,0,0-1.055.942C1059.8,625.7,1058.423,626.813,1058.423,627.139Z",
    transform: "translate(-340.901 -258.964)",
    fill: "#ffcdd3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_731",
    "data-name": "Rectangle 731",
    width: 136.619,
    height: 2.039,
    transform: "translate(596.824 352.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_732",
    "data-name": "Rectangle 732",
    width: 136.619,
    height: 2.039,
    transform: "translate(596.824 357.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_733",
    "data-name": "Rectangle 733",
    width: 136.619,
    height: 2.039,
    transform: "translate(596.824 362.332)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4324",
    "data-name": "Path 4324",
    d: "M1052.229,608.044c0-1.19-1.473-4.043.857-4.248,0-1.26-1.792-2.053-1.466-3.385.113-.453.474-.814.531-1.267.149-1.3-2.188-2-1.806-3.243.141-.474.659-.765.772-1.246.262-1.119-1.742-1.622-1.777-2.769,0-.389.213-.758.2-1.14,0-.489-.425-.857-.659-1.274-.6-1.083-.312-2.762-1.416-3.314.708.057.984-1.027.673-1.692s-.92-1.239-.92-1.976a3.146,3.146,0,0,0,0-.814c-.205-.708-1.367-.758-1.558-1.466a7.606,7.606,0,0,1,0-.8c-.071-.552-.637-.892-1.168-1.055a4.647,4.647,0,0,1-1.558-.552c-.34-.262-.708-.708-1.1-.46-.135.078-.205.234-.312.354-.432.5-1.26.283-1.813-.092a7.5,7.5,0,0,1-2.776-5c-.354-1.926-.333-3.916-.758-5.827a13.388,13.388,0,0,0-.517-1.742,9.019,9.019,0,0,1-.821-1.742c-.085-1.112,2.223-.354,3.1-.241a13.763,13.763,0,0,1,2.521.474,26.665,26.665,0,0,1,2.57,1.126c3.54,1.551,7.732,1.742,10.55,4.341.928.857,1.707,1.976,2.9,2.358a14.813,14.813,0,0,1,1.629.425c1.338.63,1.543,2.4,2.273,3.682a7.866,7.866,0,0,1,.6,1.062,4.186,4.186,0,0,1,.191,1.359l.1,3.363a124.244,124.244,0,0,1-.269,16.88,13.935,13.935,0,0,0,.064,5.523c.142.482.347.942.467,1.416a9.63,9.63,0,0,1,.184,1.749l.078,2.174a.525.525,0,0,1-.694.644c-3.038-.269-6.1-1.983-8.964-.949",
    transform: "translate(-335.132 -240.966)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4325",
    "data-name": "Path 4325",
    d: "M.814.785a.935.935,0,0,0-.34.283,2.414,2.414,0,0,0,0,2.875.971.971,0,0,1,.17.283.836.836,0,0,1-.085.482,1.593,1.593,0,0,0,.22,1.784c.219.184.517.276.658.517.248.411-.1.935-.042,1.416.071.63.814.942,1.416,1.02a1.508,1.508,0,0,0,1.381-.368,1.147,1.147,0,0,0,0-1.253,3.357,3.357,0,0,0-.935-.935A1.416,1.416,0,0,0,4.6,5.593,2.011,2.011,0,0,0,3.788,3.83c-.127-.106-.283-.212-.319-.382s.135-.4.29-.566C4.468,2.173,5.013.438,3.682.049A3.278,3.278,0,0,0,2.266.113c-.34.106-.34.312-.6.453S1.112.637.814.785Z",
    transform: "translate(642.394 393.309) rotate(-68)",
    fill: "#ffcdd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4326",
    "data-name": "Path 4326",
    d: "M997.091,545.14a2.337,2.337,0,0,0-1.8.906,5.177,5.177,0,0,0-.751,2.407,21.105,21.105,0,0,1-2.832,7.69",
    transform: "translate(-322.542 -235.842)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4327",
    "data-name": "Path 4327",
    d: "M1000.623,547.88a2.747,2.747,0,0,0-2.351,1.416,7.861,7.861,0,0,0-.595,2.4,13.043,13.043,0,0,1-2.358,5.034",
    transform: "translate(-323.596 -236.641)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4328",
    "data-name": "Path 4328",
    d: "M343.642,608.509c.411,4.475-2.967,8.808-1.983,13.184.212.935.616,1.82.765,2.762.4,2.6-1.147,5.063-2.627,7.237l-12.7,18.651a12.087,12.087,0,0,1-1.82,2.245c-2.436,2.124-6.075,1.933-9.269,2.577a15.9,15.9,0,0,0-6.2,2.747.4.4,0,0,0-.085.559,5.346,5.346,0,0,0,4.617,2.167c.333.439,0,1.083-.46,1.416-.708.474-1.622.595-1.756,1.756a1.9,1.9,0,0,0,.234,1.161,3.591,3.591,0,0,0,2.223,1.544c4.4,1.345,9.155-1.013,12.441-4.248s5.665-7.272,8.893-10.55c1.791-1.806,3.824-3.363,5.665-5.119,3.682-3.5,6.535-7.789,9.3-12.037a13.361,13.361,0,0,0,2.011-4.093c.34-1.459.184-3,.581-4.44.51-1.883,1.9-3.392,3.045-4.956a16.454,16.454,0,0,0,3.462-10.727c-.3-3.824-2.662-7.6-6.273-8.9a5.614,5.614,0,0,0-3.54-.22,8.545,8.545,0,0,0-3.583,2.832l-2.407,2.79a6.43,6.43,0,0,0-1.416,2.124,2.231,2.231,0,0,0,.5,2.372",
    transform: "translate(-123.429 -252.159)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4329",
    "data-name": "Path 4329",
    d: "M343.642,608.509c.411,4.475-2.967,8.808-1.983,13.184.212.935.616,1.82.765,2.762.4,2.6-1.147,5.063-2.627,7.237l-12.7,18.651a12.087,12.087,0,0,1-1.82,2.245c-2.436,2.124-6.075,1.933-9.269,2.577a15.9,15.9,0,0,0-6.2,2.747.4.4,0,0,0-.085.559,5.346,5.346,0,0,0,4.617,2.167c.333.439,0,1.083-.46,1.416-.708.474-1.622.595-1.756,1.756a1.9,1.9,0,0,0,.234,1.161,3.591,3.591,0,0,0,2.223,1.544c4.4,1.345,9.155-1.013,12.441-4.248s5.665-7.272,8.893-10.55c1.791-1.806,3.824-3.363,5.665-5.119,3.682-3.5,6.535-7.789,9.3-12.037a13.361,13.361,0,0,0,2.011-4.093c.34-1.459.184-3,.581-4.44.51-1.883,1.9-3.392,3.045-4.956a16.454,16.454,0,0,0,3.462-10.727c-.3-3.824-2.662-7.6-6.273-8.9a5.614,5.614,0,0,0-3.54-.22,8.545,8.545,0,0,0-3.583,2.832l-2.407,2.79a6.43,6.43,0,0,0-1.416,2.124,2.231,2.231,0,0,0,.5,2.372",
    transform: "translate(-123.429 -252.159)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4330",
    "data-name": "Path 4330",
    d: "M218.246,626.65c.708,2.238,1.416,4.475,2.273,6.656A56.326,56.326,0,0,0,226.4,644.04a77.349,77.349,0,0,0,4.864,6.373c2.167,2.556,4.588,5.126,5.353,8.391a42.492,42.492,0,0,1,.481,5.785,7.064,7.064,0,0,0,2.372,5.126A8.815,8.815,0,0,0,243.382,671c.977.156,2.2.205,2.712-.644a2.415,2.415,0,0,0,.269-1.119l.241-2.832c.05-.609.262-1.416.871-1.416s.921.786,1.416,1.147a1.536,1.536,0,0,0,2.124-.708,3.541,3.541,0,0,0,.057-2.478,11.768,11.768,0,0,0-6.04-7.484,18.15,18.15,0,0,1-2.946-1.536,10.018,10.018,0,0,1-2.315-2.917c-5.353-8.815-10.734-17.7-14.516-27.268a20.172,20.172,0,0,1-1.494-5.374,34.69,34.69,0,0,1,.234-5.665,32.423,32.423,0,0,0-.935-10.111,7.951,7.951,0,0,0-.97-2.457c-1.551-2.365-5.211-2.712-7.52-1.083a7.747,7.747,0,0,0-2.988,5.466c-.17,1.9.935,3.894,1.494,5.665Q215.675,618.415,218.246,626.65Z",
    transform: "translate(-94.798 -251.288)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4331",
    "data-name": "Path 4331",
    d: "M218.246,626.65c.708,2.238,1.416,4.475,2.273,6.656A56.326,56.326,0,0,0,226.4,644.04a77.349,77.349,0,0,0,4.864,6.373c2.167,2.556,4.588,5.126,5.353,8.391a42.492,42.492,0,0,1,.481,5.785,7.064,7.064,0,0,0,2.372,5.126A8.815,8.815,0,0,0,243.382,671c.977.156,2.2.205,2.712-.644a2.415,2.415,0,0,0,.269-1.119l.241-2.832c.05-.609.262-1.416.871-1.416s.921.786,1.416,1.147a1.536,1.536,0,0,0,2.124-.708,3.541,3.541,0,0,0,.057-2.478,11.768,11.768,0,0,0-6.04-7.484,18.15,18.15,0,0,1-2.946-1.536,10.018,10.018,0,0,1-2.315-2.917c-5.353-8.815-10.734-17.7-14.516-27.268a20.172,20.172,0,0,1-1.494-5.374,34.69,34.69,0,0,1,.234-5.665,32.423,32.423,0,0,0-.935-10.111,7.951,7.951,0,0,0-.97-2.457c-1.551-2.365-5.211-2.712-7.52-1.083a7.747,7.747,0,0,0-2.988,5.466c-.17,1.9.935,3.894,1.494,5.665Q215.675,618.415,218.246,626.65Z",
    transform: "translate(-94.798 -251.288)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4332",
    "data-name": "Path 4332",
    d: "M368.171,755.055c-2.776,1.692-6.231,1.792-9.46,1.416-.517-.064-1.133-.106-1.466.3-.481.581.085,1.416.673,1.912a14.078,14.078,0,0,0,6.5,2.669,44.337,44.337,0,0,0,6.373.425,107.743,107.743,0,0,0,17.369-.644,2.3,2.3,0,0,0,.949-.276,1.8,1.8,0,0,0,.708-1.091,4.34,4.34,0,0,0-1.515-4.135,12.744,12.744,0,0,0-4.05-2.174l-5.042-1.961c-1.182-.46-3.087-1.685-4.369-1.586C372.462,750.063,370.175,753.88,368.171,755.055Z",
    transform: "translate(-137.273 -295.617)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4333",
    "data-name": "Path 4333",
    d: "M386.369,771.115a12.385,12.385,0,0,1-8.462,3.158c-.793,0-1.9.149-1.9.942a1.246,1.246,0,0,0,.227.658,7.789,7.789,0,0,0,4.376,3.427,15.58,15.58,0,0,0,5.282.333l5.169-.269c.977-.05,1.961-.1,2.931-.219s2.025-.319,3.038-.474a40.514,40.514,0,0,1,7.527-.354,2.188,2.188,0,0,0,1.855-.5c.46-.581.191-1.416.042-2.124-.312-1.494,0-3.066-.29-4.574-.5-2.634-2.761-4.659-5.275-5.615-2.322-.885-6.443-1.9-8.646-.425C389.881,766.647,388.458,769.224,386.369,771.115Z",
    transform: "translate(-142.804 -299.83)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4334",
    "data-name": "Path 4334",
    d: "M374.643,667.644c-2.124,2.8-4.248,6.026-3.753,9.481.283,1.862,1.324,3.5,2.089,5.233a36.88,36.88,0,0,1,2.124,7.35c.786,3.661,1.572,7.329,2.061,11.039a68.941,68.941,0,0,1,.46,12.675,4.276,4.276,0,0,1-.885,2.832c-.283.283-.651.517-.772.9a1.523,1.523,0,0,0,.163,1.062,11.761,11.761,0,0,0,6.3,5.8,24.138,24.138,0,0,0,8.568,1.6,2.407,2.407,0,0,0,1.147-.149,2.209,2.209,0,0,0,.885-1.013c2.124-4.036.942-8.908.977-13.453,0-3.8.921-7.569.758-11.372-.135-3.045-.949-6.019-1.246-9.056-.489-4.957.425-9.984,1.338-14.9.708-3.767,1.416-7.541,2.3-11.273a21.5,21.5,0,0,1,2.436-6.543c.991-1.565,2.337-2.875,3.47-4.348a19.734,19.734,0,0,0,3.88-14.424c-.071-.51-7.293,1.827-7.916,2.124a24.544,24.544,0,0,0-7.081,4.539,58.628,58.628,0,0,0-4.447,5.495q-3.1,3.774-6.1,7.591Q377.971,663.2,374.643,667.644Z",
    transform: "translate(-141.288 -263.244)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    "data-name": "Path 4335",
    d: "M374.643,667.644c-2.124,2.8-4.248,6.026-3.753,9.481.283,1.862,1.324,3.5,2.089,5.233a36.88,36.88,0,0,1,2.124,7.35c.786,3.661,1.572,7.329,2.061,11.039a68.941,68.941,0,0,1,.46,12.675,4.276,4.276,0,0,1-.885,2.832c-.283.283-.651.517-.772.9a1.523,1.523,0,0,0,.163,1.062,11.761,11.761,0,0,0,6.3,5.8,24.138,24.138,0,0,0,8.568,1.6,2.407,2.407,0,0,0,1.147-.149,2.209,2.209,0,0,0,.885-1.013c2.124-4.036.942-8.908.977-13.453,0-3.8.921-7.569.758-11.372-.135-3.045-.949-6.019-1.246-9.056-.489-4.957.425-9.984,1.338-14.9.708-3.767,1.416-7.541,2.3-11.273a21.5,21.5,0,0,1,2.436-6.543c.991-1.565,2.337-2.875,3.47-4.348a19.734,19.734,0,0,0,3.88-14.424c-.071-.51-7.293,1.827-7.916,2.124a24.544,24.544,0,0,0-7.081,4.539,58.628,58.628,0,0,0-4.447,5.495q-3.1,3.774-6.1,7.591Q377.971,663.2,374.643,667.644Z",
    transform: "translate(-141.288 -263.244)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    "data-name": "Path 4336",
    d: "M393.6,644.625c.453,2.167,2.556,3.824,2.613,6.04.05,1.77-1.211,3.257-2.124,4.779a32.062,32.062,0,0,0-2.167,4.914,74.933,74.933,0,0,1-6.373,12.653c-1.211,1.926-2.57,4.015-2.287,6.274a9.264,9.264,0,0,0,1.1,3L388,689.51a20.749,20.749,0,0,1,1.855,4.567c.319,1.374.347,2.832.531,4.192.574,4.433,2.648,8.893,1.416,13.191-.106.368-.5.814-.786.559a13.775,13.775,0,0,1,2.075,7.081c-.042,1.338-.453,2.726.043,3.972a4.335,4.335,0,0,1,.552,1.515c0,.361-.17.708-.205,1.069a2.368,2.368,0,0,0,1.813,2.2c.977.326,2.039.3,3.023.595,1.9.567,3.243,2.2,4.872,3.328a10.231,10.231,0,0,0,5.587,1.82,1.416,1.416,0,0,0,.821-.163,1.345,1.345,0,0,0,.46-1,5.551,5.551,0,0,0-2-4.822,2.232,2.232,0,0,1-.708-.779,1.89,1.89,0,0,1-.071-.871,64.583,64.583,0,0,0-.212-11.931,18.406,18.406,0,0,1-.184-3.8,15.515,15.515,0,0,0,.3-3.165,16.157,16.157,0,0,0-.97-3.023,21.194,21.194,0,0,1-.46-5.665,49.65,49.65,0,0,0-1.6-9.694,7.357,7.357,0,0,0-1.508-3.5c-.758-.793-1.983-1.544-1.692-2.6a3,3,0,0,1,.708-1.034,4.15,4.15,0,0,0,.871-3.165,1.416,1.416,0,0,0,1.629-.765,25.49,25.49,0,0,0,12.8-14.558,4.728,4.728,0,0,1,.574-1.3,5.908,5.908,0,0,1,2.344-1.522c2.648-1.331,4.475-3.831,6.153-6.273a14.6,14.6,0,0,0,2.379-4.553,15,15,0,0,0,.326-3.285l.149-5.665a3.25,3.25,0,0,0-.106-1.112,2.834,2.834,0,0,0-.616-.906,11,11,0,0,0-6.047-3.257c-1.551-.276-3.137-.227-4.709-.354-3.045-.255-6.054-1.2-9.106-.977-4.787.354-9.049,3.675-11.329,7.909C396.137,643.3,395.3,644.575,393.6,644.625Z",
    transform: "translate(-144.911 -261.736)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    "data-name": "Path 4337",
    d: "M173.048,764.724a7.711,7.711,0,0,0,3.257.389c.078-.9,1.289-1.1,2.188-1.055a2.514,2.514,0,0,1,1.289.283c.227.142.4.354.616.5a2.649,2.649,0,0,0,1.275.326l4.687.4a14.036,14.036,0,0,0,6.217-.411,2.032,2.032,0,0,0,1-.666c.531-.758,0-1.848-.708-2.4s-1.678-.807-2.415-1.374c-1.629-1.239-1.848-3.54-2.712-5.41a15.613,15.613,0,0,0-2.238-3.25,12.441,12.441,0,0,0-2.216-2.266c-1.876-1.359-4.043-1.331-6.245-1.522-1.558-.142-3.023-.234-4.142,1.147-1.381,1.713-.828,5.169-.743,7.215a51.647,51.647,0,0,0,.892,8.093Z",
    transform: "translate(-83.241 -295.118)",
    fill: "#d8a251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4338",
    "data-name": "Path 4338",
    d: "M173.048,764.724a7.711,7.711,0,0,0,3.257.389c.078-.9,1.289-1.1,2.188-1.055a2.514,2.514,0,0,1,1.289.283c.227.142.4.354.616.5a2.649,2.649,0,0,0,1.275.326l4.687.4a14.036,14.036,0,0,0,6.217-.411,2.032,2.032,0,0,0,1-.666c.531-.758,0-1.848-.708-2.4s-1.678-.807-2.415-1.374c-1.629-1.239-1.848-3.54-2.712-5.41a15.613,15.613,0,0,0-2.238-3.25,12.441,12.441,0,0,0-2.216-2.266c-1.876-1.359-4.043-1.331-6.245-1.522-1.558-.142-3.023-.234-4.142,1.147-1.381,1.713-.828,5.169-.743,7.215a51.647,51.647,0,0,0,.892,8.093Z",
    transform: "translate(-82.87 -295.118)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4339",
    "data-name": "Path 4339",
    d: "M171.641,641.3c-1.416.46-2.053,2.245-1.791,3.732a13.4,13.4,0,0,0,1.891,4.071c2.082,3.732,2.988,8,4.737,11.9,1.31,2.91,3.08,5.6,4.376,8.5s2.124,6.21,1.31,9.3c-.382,1.508-1.119,2.9-1.614,4.369a24.782,24.782,0,0,0-.949,4.956,93.95,93.95,0,0,0-.34,17.107,5.2,5.2,0,0,0,.432,2.025c.29.566.8,1.161.552,1.749-.1.234-.312.4-.418.637-.3.651.3,1.331.85,1.791a1.466,1.466,0,0,1-.921.708,2.174,2.174,0,0,1,.928,2.422c-.489.071-.517.814-.205,1.2s.786.637,1.005,1.076a1.508,1.508,0,0,1-.828,1.9,3.881,3.881,0,0,1-2.259.17,24.482,24.482,0,0,1-3.781-.828,3.4,3.4,0,0,1-1.161-.531,3.448,3.448,0,0,1-1.041-2.294,41.46,41.46,0,0,1-.262-7.081c.205-11.443,0-22.9-.5-34.335a39.315,39.315,0,0,0-3.37-13.34A68.438,68.438,0,0,0,165,654.125c-2.563-4.716-4.843-9.913-4.248-15.259.064-.574.276-1.267.843-1.359a1.226,1.226,0,0,1,.651.106,30.124,30.124,0,0,1,3.434,1.9,13.015,13.015,0,0,0,5.962,1.784Z",
    transform: "translate(-79.936 -262.804)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4340",
    "data-name": "Path 4340",
    d: "M171.641,641.3c-1.416.46-2.053,2.245-1.791,3.732a13.4,13.4,0,0,0,1.891,4.071c2.082,3.732,2.988,8,4.737,11.9,1.31,2.91,3.08,5.6,4.376,8.5s2.124,6.21,1.31,9.3c-.382,1.508-1.119,2.9-1.614,4.369a24.782,24.782,0,0,0-.949,4.956,93.95,93.95,0,0,0-.34,17.107,5.2,5.2,0,0,0,.432,2.025c.29.566.8,1.161.552,1.749-.1.234-.312.4-.418.637-.3.651.3,1.331.85,1.791a1.466,1.466,0,0,1-.921.708,2.174,2.174,0,0,1,.928,2.422c-.489.071-.517.814-.205,1.2s.786.637,1.005,1.076a1.508,1.508,0,0,1-.828,1.9,3.881,3.881,0,0,1-2.259.17,24.482,24.482,0,0,1-3.781-.828,3.4,3.4,0,0,1-1.161-.531,3.448,3.448,0,0,1-1.041-2.294,41.46,41.46,0,0,1-.262-7.081c.205-11.443,0-22.9-.5-34.335a39.315,39.315,0,0,0-3.37-13.34A68.438,68.438,0,0,0,165,654.125c-2.563-4.716-4.843-9.913-4.248-15.259.064-.574.276-1.267.843-1.359a1.226,1.226,0,0,1,.651.106,30.124,30.124,0,0,1,3.434,1.9,13.015,13.015,0,0,0,5.962,1.784Z",
    transform: "translate(-79.936 -262.804)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4341",
    "data-name": "Path 4341",
    d: "M143.987,622.886a3.775,3.775,0,0,0-5.2.559,28.442,28.442,0,0,0-2.691,2.365,14.4,14.4,0,0,0-3.215,14.239,28.454,28.454,0,0,0,3.937,6.982l3.116,4.475c4.751,6.826,9.509,13.652,14.487,20.315a.765.765,0,0,0,.538.708c.184.05.4.042.517.191a.552.552,0,0,1,.064.3,4.623,4.623,0,0,1-.276,1.416.659.659,0,0,0-.057.489c.156.375.843.163,1.055.517a.563.563,0,0,1-.227.708.819.819,0,0,0-.389.708c.035.29.51.559.489.914,0,.2-.17.347-.29.5a1.282,1.282,0,0,0,.156,1.636c.326,3.257-1.416,6.337-1.791,9.594-.559,5.119,1.756,10.118,2.039,15.259a4.085,4.085,0,0,0,.319,1.685c.481.885,1.714,1.416,1.671,2.429a9.272,9.272,0,0,1-.347,1.225,9.849,9.849,0,0,0,.184,1.749c0,.588-.5,1.289-1.041,1.062q.616,2.039,1.09,4.114l10.9.9a9.794,9.794,0,0,0-.1-2.946c-.227-1.048-.708-2.032-.949-3.08a3.633,3.633,0,0,1,.432-3.08,1.2,1.2,0,0,1-1.2-.991,4.857,4.857,0,0,1,0-1.692c.29-2.832-.906-5.665-.871-8.5.035-2.252.821-4.411,1.225-6.62.85-4.73-.035-9.864,2.068-14.162,1.275-2.606,3.038-5.495,1.607-8.015-.708-1.246-1.947-2.124-2.754-3.271a13.29,13.29,0,0,1-1.48-3.54c-1.685-5.211-4.4-10.019-6.783-14.955a15.738,15.738,0,0,1-1.459-3.93,19.972,19.972,0,0,1-.177-3.625,55.57,55.57,0,0,0-.4-6.514,4.749,4.749,0,0,0-2.492-4.248C152.109,626.327,147.846,624.918,143.987,622.886Z",
    transform: "translate(-71.627 -258.308)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4342",
    "data-name": "Path 4342",
    d: "M166.837,770.367a7.713,7.713,0,0,0,3.257.389c.085-.9,1.289-1.1,2.188-1.055a2.514,2.514,0,0,1,1.253.29c.227.142.4.354.623.5a2.607,2.607,0,0,0,1.275.326l4.68.4a14.073,14.073,0,0,0,6.224-.411,2.046,2.046,0,0,0,.991-.666c.531-.758,0-1.848-.708-2.4s-1.678-.807-2.422-1.374c-1.621-1.239-1.848-3.54-2.712-5.41a15.609,15.609,0,0,0-2.238-3.25,12.405,12.405,0,0,0-2.209-2.266c-1.883-1.359-4.043-1.331-6.245-1.522-1.565-.142-3.031-.234-4.142,1.147-1.416,1.713-.836,5.169-.751,7.215a52.608,52.608,0,0,0,.935,8.086Z",
    transform: "translate(-81.413 -296.767)",
    fill: "#d8a251"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_675",
    "data-name": "Rectangle 675",
    width: 55.251,
    height: 55.251,
    transform: "translate(144.548 391.47)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 10.798,
    cy: 10.798,
    r: 10.798,
    transform: "translate(122.945 324.104)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    "data-name": "Path 4343",
    d: "M212.568,584.961c-1.551,1.338-3.767,1.416-5.8,1.643a36.245,36.245,0,0,0-12.476,3.611,4.454,4.454,0,0,0-1.416.991,4.086,4.086,0,0,0-.708,1.544,10.21,10.21,0,0,0-.411,3.753,10.818,10.818,0,0,0,1.041,3.54,19,19,0,0,0,6.7,7.633,4.865,4.865,0,0,0,1.629.779c1.416.3,2.8-.531,4.192-.9a6.868,6.868,0,0,1,3.873.127c1.175.389,2.415,1.1,3.54.63a3.7,3.7,0,0,0,1.614-1.834,62.226,62.226,0,0,0,2.946-6.451,24.445,24.445,0,0,1,1.069-2.507c1.253-2.386,3.42-4.248,4.5-6.7a1.473,1.473,0,0,0,.1-1.26,1.749,1.749,0,0,0-.793-.609,18.922,18.922,0,0,1-4.312-3.385c-.708-.708-2.018-2.521-3.038-2.684C213.694,582.737,213.347,584.295,212.568,584.961Z",
    transform: "translate(-89.007 -246.858)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    "data-name": "Path 4344",
    d: "M199.873,609.986a6.443,6.443,0,0,1-4.086.05,45.088,45.088,0,0,1-10.267-2.988A5.494,5.494,0,0,1,183,605.114a6.181,6.181,0,0,1-.708-2.422l-.595-4.015a24.342,24.342,0,0,1,.184-4.121,1.2,1.2,0,0,0-.234-.9.97.97,0,0,0-.708-.219c-1.621,0-2.6,1.721-3.739,2.875a6.9,6.9,0,0,1-2.294,1.544c-1.041.425-2.322.708-2.74,1.763-.177.432-.156.927-.333,1.359-.708,1.728-3.824,1.154-4.61,2.832-.227.481-.212,1.09-.588,1.473s-1.062.368-1.629.467c-2.252.368-3.349,2.974-5.275,4.2-1.621,1.034-3.71,1.012-5.452,1.82a20.9,20.9,0,0,1-2.832,1.416,13.386,13.386,0,0,1-3.285.163.886.886,0,0,0-.659.213.906.906,0,0,0-.106.708,19.876,19.876,0,0,0,12.285,15.386,4.334,4.334,0,0,1,1.048.5c.984.708,1.154,2.315,2.266,2.832a2.344,2.344,0,0,0,2.365-.51,20.593,20.593,0,0,0,1.706-1.884,6.8,6.8,0,0,1,3.8-2c1.338-.212,2.832-.057,3.916-.878a12.048,12.048,0,0,0,1.232-1.317,7.724,7.724,0,0,1,2.832-1.671,28.321,28.321,0,0,1,8.851-1.869c2.832-.163,5.771.1,8.454-.828a4.957,4.957,0,0,0,1.883-1.062,5.665,5.665,0,0,0,1.26-2.188A16.7,16.7,0,0,0,199.873,609.986Z",
    transform: "translate(-76.057 -249.94)",
    fill: "#d8a251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    "data-name": "Path 4345",
    d: "M199.37,594.244c.8-.071,1.6,0,2.4,0,.942,0,1.869-.227,2.832-.234a6.982,6.982,0,0,1,6.585,5.013,1.275,1.275,0,0,1,.042.708.5.5,0,0,1-.545.368,11.967,11.967,0,0,0-1.211-2.429,6.876,6.876,0,0,0-3.625-2.521,9.411,9.411,0,0,0-4.461-.163c-.609.113-1.211.276-1.813.446l-2.939.793c-.531.142-1.062.29-1.579.482-.4.141-1.083.708-1.473.708-.531,0-.1-.46.135-.772a3.781,3.781,0,0,1,1.883-1.367,15.851,15.851,0,0,1,3.767-1.034Z",
    transform: "translate(-89.476 -250.108)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    "data-name": "Path 4346",
    d: "M209.4,628.351c.708,2.237,1.416,4.475,2.273,6.656a56.326,56.326,0,0,0,5.891,10.734,77.345,77.345,0,0,0,4.864,6.373c2.167,2.556,4.588,5.126,5.353,8.391a42.5,42.5,0,0,1,.481,5.785,7.064,7.064,0,0,0,2.372,5.126,8.816,8.816,0,0,0,3.909,1.289c.977.156,2.2.205,2.712-.644a2.415,2.415,0,0,0,.269-1.119l.234-2.832c.057-.609.269-1.416.878-1.416s.921.786,1.416,1.147a1.536,1.536,0,0,0,2.124-.708,3.59,3.59,0,0,0,.057-2.478,11.768,11.768,0,0,0-6.026-7.491,18.16,18.16,0,0,1-2.946-1.536,9.913,9.913,0,0,1-2.315-2.917c-5.36-8.816-10.742-17.7-14.516-27.268a20.174,20.174,0,0,1-1.494-5.374,34.693,34.693,0,0,1,.234-5.665,32.422,32.422,0,0,0-.913-10.125,7.95,7.95,0,0,0-.97-2.457c-1.551-2.365-5.211-2.712-7.52-1.083a7.746,7.746,0,0,0-2.988,5.466c-.17,1.9.935,3.894,1.494,5.665Q206.84,620.116,209.4,628.351Z",
    transform: "translate(-92.229 -251.778)",
    fill: "#a1616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    "data-name": "Path 4347",
    d: "M241.992,566.717c.085-.9-.708-1.714-1.636-2.287a22.844,22.844,0,0,1-2.776-1.7c-.821-.708-1.267-1.636-2.089-2.344a9.206,9.206,0,0,0-3.116-1.551,23.649,23.649,0,0,0-7.449-1.338,13.119,13.119,0,0,0-7.13,1.883,4.248,4.248,0,0,0-1.211,1.126A4.957,4.957,0,0,0,216,562.3a35.407,35.407,0,0,1-1.862,5.665,13.142,13.142,0,0,1-3.54,5.721c-2.018,1.685-5.112,2.655-6.443,4.687a1.522,1.522,0,0,0-.29,1.31c.191.51.807.857,1.367,1.183,3.278,1.883,6.1,4.319,7.562,7.236a8.391,8.391,0,0,1-.666,9.028c-.758.991-1.806,2.167-1.062,3.165,1.126,1.515,5.013.651,5.905,2.252a3.2,3.2,0,0,1,.12,1.657c0,1.678,1.621,3.179,3.59,3.951a20.016,20.016,0,0,0,6.458,1.062,5.58,5.58,0,0,0,.163-4.178,1.671,1.671,0,0,1-.163-.949,2.28,2.28,0,0,1,.708-.913c2.372-2.238,1.869-5.53.446-8.185s-3.632-5.091-4.454-7.888a4.006,4.006,0,0,1,.708-4.107,14.3,14.3,0,0,1,2.032-1.487,7.725,7.725,0,0,0,2.832-3.54c.658-1.841.559-4.057,2.5-5.275s4.454-.821,6.5-1.607A6.967,6.967,0,0,0,241.992,566.717Z",
    transform: "translate(-92.537 -239.448)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 11.775,
    cy: 11.775,
    r: 11.775,
    transform: "translate(198.227 319.311)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    "data-name": "Path 4348",
    d: "M353.572,574.279a15.266,15.266,0,0,0,9.771,6.833l-.885,3.215c-1.529,5.537-3.257,11.4-7.534,15.238a7.123,7.123,0,0,0-1.2-5.509,20.859,20.859,0,0,0-3.994-4.178l-6.776-5.9a1.847,1.847,0,0,1-.51-.566,1.728,1.728,0,0,1,0-1.289c.864-2.691,3.328-4.369,5.325-6.182a18.774,18.774,0,0,0,2.684-3.123C351.845,570.908,352.716,572.841,353.572,574.279Z",
    transform: "translate(-132.97 -243.689)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4349",
    "data-name": "Path 4349",
    d: "M358.153,591.537a6.373,6.373,0,0,1-.347,2.6,1.827,1.827,0,0,1-2.124,1.09c.248-.559-.4-1.2-1.013-1.126a1.9,1.9,0,0,0-1.345,1.14,4.249,4.249,0,0,0-.389,2.634c.191,1.119.835,2.188.666,3.307-.135.928-.821,1.855-.453,2.726a4.377,4.377,0,0,0,.878,1.048,2.974,2.974,0,0,1-.319,4.079l9.205.177a6.457,6.457,0,0,0,1.14,4.468,28.131,28.131,0,0,0,20.973,13.694,1.827,1.827,0,0,0-.439,2.79,2.582,2.582,0,0,0,2.946.17,22.351,22.351,0,0,0,2.528-1.891,7.725,7.725,0,0,1,5.183-1.416c1.154.106,2.266.474,3.42.538,3.4.184,6.323-2.266,9.573-3.264,2.386-.708,5.084-.708,7.081-2.223a2.808,2.808,0,0,0,1.317-2.733,4.454,4.454,0,0,0-.991-1.6,28.5,28.5,0,0,1-2.655-4.957,29.591,29.591,0,0,0-6.635-8.879,58.575,58.575,0,0,0-6.571-4.992A11.115,11.115,0,0,0,398,597.846a18.281,18.281,0,0,1-2.436-.991,13.588,13.588,0,0,1-2.528-2.832c-1.82-2.124-4.617-3.094-6.861-4.765-1.5-1.119-2.832-2.591-4.624-3.137-.871-.262-1.806-.283-2.676-.545-1.983-.6-3.427-2.365-5.374-3.073-1.537-.566-3.236-.418-4.864-.623a11.33,11.33,0,0,1-5-1.891,6.012,6.012,0,0,0-1.614-.949c-2.457-.708-2.655,3.838-2.889,5.424A45.469,45.469,0,0,0,358.153,591.537Z",
    transform: "translate(-136.049 -245.716)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    "data-name": "Path 4350",
    d: "M349.688,615.347c.411,4.468-2.967,8.8-1.983,13.184.212.935.609,1.82.758,2.761.411,2.6-1.14,5.056-2.62,7.229L333.1,657.173a11.328,11.328,0,0,1-1.813,2.245c-2.436,2.16-6.075,1.933-9.269,2.584a15.868,15.868,0,0,0-6.21,2.747.4.4,0,0,0-.078.552,5.325,5.325,0,0,0,4.617,2.167c.333.439,0,1.09-.46,1.416-.708.474-1.622.6-1.756,1.756a1.969,1.969,0,0,0,.227,1.168,3.625,3.625,0,0,0,2.23,1.544c4.4,1.345,9.148-1.02,12.441-4.248s5.665-7.272,8.893-10.55c1.791-1.813,3.824-3.363,5.665-5.119a66.938,66.938,0,0,0,9.3-12.037,13.4,13.4,0,0,0,2.011-4.1c.34-1.452.184-3,.581-4.433.51-1.891,1.891-3.4,3.045-4.956a16.472,16.472,0,0,0,3.462-10.734c-.3-3.831-2.669-7.6-6.274-8.9a5.615,5.615,0,0,0-3.54-.212,8.437,8.437,0,0,0-3.583,2.832l-2.415,2.79a6.628,6.628,0,0,0-1.416,2.124,2.23,2.23,0,0,0,.5,2.372",
    transform: "translate(-125.184 -254.154)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4351",
    "data-name": "Path 4351",
    d: "M369.411,592.437c-1.671.1-3.54.262-4.695,1.416a6.556,6.556,0,0,0-1.175,1.855,18.326,18.326,0,0,0-2.344,7.371,33.234,33.234,0,0,0,.85,6.16c.262,1.706-.4,3.448-.531,5.176a35.343,35.343,0,0,0,6.684-2.57,22.355,22.355,0,0,1,3.916-2.032c1.99-.665,5.346.474,7.229,1.416.106-1.331-.892-3.647-.786-4.957a5.431,5.431,0,0,1,.3-1.65,9.833,9.833,0,0,1,1-1.593,6.521,6.521,0,0,0-.588-7.654c-1.678-1.891-4.312-2.6-6.826-2.9a29.844,29.844,0,0,0-4.772-.163",
    transform: "translate(-138.478 -249.604)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4352",
    "data-name": "Path 4352",
    d: "M320.116,555.291l-.269-2.216c1.862.474,3.625-1.1,4.815-2.733s2.287-3.54,4.093-4.249c2.2-.828,4.532.5,6.635,1.586A20.766,20.766,0,0,0,343,550.2a5.4,5.4,0,0,1,1.26.205c1.367.489,2.018,2.2,2.216,3.76s.142,3.215.814,4.6c.517,1.048,1.416,1.834,1.926,2.832,1.416,2.783.05,6.592,1.572,9.325l-3.774-3.455c-.347-.319-.836-.651-1.211-.382s-.326.708-.453,1.041a1.975,1.975,0,0,1-2.684.977,7.356,7.356,0,0,1-2.4-2.195,14.67,14.67,0,0,0-5.99-4.539,7.655,7.655,0,0,0-6.337.375c-1.763,1-3.052,3.314-5.211,3.392-2.96.113-4.192-5.4-5.558-7.569a2.684,2.684,0,0,0,.779-3.342C318.154,555.156,320.073,554.951,320.116,555.291Z",
    transform: "translate(-125.627 -236.044)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4358",
    "data-name": "Path 4358",
    d: "M703.831,483.272a16.484,16.484,0,1,1,11.729-4.828,16.631,16.631,0,0,1-11.729,4.828Zm-71.6,10.818a44.153,44.153,0,1,1-44.153,44.153,44.153,44.153,0,0,1,44.153-44.153m0-22.077a66.23,66.23,0,1,0,66.23,66.23A66.23,66.23,0,0,0,632.229,472.013Z",
    transform: "translate(90.973 -366.961)",
    fill: "#d8a251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4361",
    "data-name": "Path 4361",
    d: "M728.852,756.61c-.574-2.429-.921-4.553-.921-4.553a9.431,9.431,0,0,0-1.055-4.624v-.666h0v-4.886a16.146,16.146,0,0,1,1.232-2.556c.878-1.529,0-7.152,0-7.152s-3.257-7.923-2.471-12.951-6.684-22.326-6.684-22.326a22.051,22.051,0,0,1,.708-4.957,3.579,3.579,0,0,0,.092-1.034.765.765,0,0,0,0-.127v.042c-.113-3.314-2.733-9.531-2.733-9.531l.354-11.839a34.868,34.868,0,0,0-1.055-16.364c-.956-3.271-1.565-5.884-1.954-7.909-.042-.227-.085-.446-.12-.659,5.615-.857,9.913-1.572,9.913-1.572s-3.257-13.63-5.459-16.017-3.958-9.878-3.958-9.878-1.147-9.63.708-12.441,2.124-7.668,2.124-7.668,4.248-3.066,4.751-4.433a22.445,22.445,0,0,0,1.416-6.047c0-1.621-.531-3.066-.354-3.923s-1.232-4.086-.524-5.622a4.117,4.117,0,0,0,.276-1.48.092.092,0,0,0,0-.042h0a21.048,21.048,0,0,0-.375-4,11.332,11.332,0,0,0-4.178-2.237l-.092-.361-.241-.956a3.242,3.242,0,0,0-.418-.248v-1.77l.658-3.116c1.3-5.4-5.919-6.21-5.919-6.21a3.809,3.809,0,0,0-2.046-1.8c-1.416-.51-.241,8.143.439,8.7a28.164,28.164,0,0,1,2.832,4.461h0l.128.22a2.869,2.869,0,0,0-.333.347l.276,1.876.042.29a7.712,7.712,0,0,0-1.154,1.961,4.185,4.185,0,0,1,1.055,3.073,9.63,9.63,0,0,0,.439,3.746c-.078-.092-1.006-1.1-1.933-.85s-3.54,1.02-3.54,1.02-1.94.34-1.763.765-1.317,2.3-1.317,2.3l-5.2-4.956c-.057-.149-.106-.3-.156-.446a11.9,11.9,0,0,1-.446-2.124,11.558,11.558,0,0,0,1.657-.531,3.592,3.592,0,0,0,1.416-.921,5.623,5.623,0,0,0,.836-2.245,31.163,31.163,0,0,1,1.933-4.305,14.007,14.007,0,0,0,1.005-7.683,5.113,5.113,0,0,0-.793-2.266c-.85-1.168-2.393-1.643-3.54-2.577s-1.841-2.351-3.151-3.052a6.21,6.21,0,0,0-3.951-.34,21.113,21.113,0,0,0-7.371,2.677,3.79,3.79,0,0,1-2.471.814,3.335,3.335,0,0,1-1.777-1.3.346.346,0,0,1,0-.078l-.064-.064a9.323,9.323,0,0,0-.807,3.894v.836a1.654,1.654,0,0,1,0,.184h0a1.246,1.246,0,0,1-.043.276,2,2,0,0,1-.481.708,3.135,3.135,0,0,0-.425.581.626.626,0,0,1,.071-.212,3.072,3.072,0,0,0-.545,1.636,1.628,1.628,0,0,0,.4,1.175,5.666,5.666,0,0,0,.843.708,9.912,9.912,0,0,0-.149,1.728,10.069,10.069,0,0,0,4.9,8.589l.177.446a12.385,12.385,0,0,1,.942,5.665.956.956,0,0,1-.064.418l-.184.212h0s-8.6.085-10.621-1.749-5.105,4.475-5.105,4.475-3.08.6-3.7,0-4.248-.085-4.248-.085a7.788,7.788,0,0,0-5.367-1.954,15.772,15.772,0,0,0-3.944-2.2h0l-.1-.035h0a4.4,4.4,0,0,0-1.94-.241s-4.248-3.5-5.452-5.367-7.081-8.83-7.13-8.865V563.7l-.071-1.013a3.959,3.959,0,0,1-.524.05,1.234,1.234,0,0,0-.12-.354,19.121,19.121,0,0,0-1.246-2.832s0-1.275.375-1.593-.156-5.006-.156-5.006-3.809-8.9-7.215-2.259c0,0-6.451,4.3-1.041,9.311,0,0,2.124,1.041,2.464,1.869.205.538.935,2.046,1.416,3.045l.219.446-.064.05.085.836v.326c-1.02.574-1.706,1.147-1.544,1.586a9.317,9.317,0,0,1,.616,2.3s7.484,9.368,8.454,13.375c0,0,20.067,11.924,26.666,12.781l-1.14,5.962a47.127,47.127,0,0,0-.262,4.857c.085,1.274-.793,7.081-.793,7.081s-1.147,8.5-2.124,9.708-.793,6.309-.793,6.309a42.555,42.555,0,0,1-1.317,7.237,18.39,18.39,0,0,0-.262,7.243s-3.349,7.669,4.666,2.471c0,0,3.93-.241,8.5-.4v2.33c-.057,4.39-.085,10.444.113,15.025.354,8.093,2.832,24.075,2.832,24.075v8.044a11.25,11.25,0,0,0-.227,2.3,14.912,14.912,0,0,0,2.167,8.058l.616,5.367a22.232,22.232,0,0,1,1.473,5.665,2.783,2.783,0,0,1-.064.51,3.807,3.807,0,0,0-.071.821c-.078,2.436,1.416,8.27,1.416,8.27s.092,5.877.97,6.217c.751.29-1.005,3.392-1.529,4.249a1.444,1.444,0,0,1-.035-.17c-.064.113-.106.177-.106.177a4.129,4.129,0,0,0-.276,1.487,2.124,2.124,0,0,0,.977,2.068c1.671,1.027,2.57,1.876,1.154,2.216a14.047,14.047,0,0,0-1.551.326c0-.064-.057-.134-.078-.2a.949.949,0,0,0-.552.984,4.355,4.355,0,0,0,.531,1.99,21.246,21.246,0,0,0,2.379,4.348l.708-.078a3.345,3.345,0,0,1-.4.708,2.741,2.741,0,0,1-.991.878,3.172,3.172,0,0,1-1.2.418,3.356,3.356,0,0,0-2.492,1.211c-.878,1.133-1.416,2.684.3,4.043L687.8,760.6s10.826,1.416,10.253-1.02-.92-4.553-.92-4.553a9.609,9.609,0,0,0-.885-4.312,4.257,4.257,0,0,0-.382-.637l.382-.042s.793-5.367,1.848-6.373c.248-.234.3-.418.241-.559.113-.29-.163-.46-.517-.559l-.078.212a5.318,5.318,0,0,0-1.048-.113s-.354-2.832.786-3.838a1.083,1.083,0,0,0,.227-.836,4.807,4.807,0,0,0-.12-1.147l-.042.071a40.885,40.885,0,0,0-2.528-6.606s-.085-2.556.616-3.583-.085-13.885-.085-13.885.262-6.217-.531-9.113.97-6.309.97-6.309v-.227s-.042-.382-.106-.984v.064c-.177-1.65-.51-4.631-.758-6-.354-1.961.085-11.329.085-11.329l1.586-4,2.832,6.9,2.988,9.2a7.825,7.825,0,0,1,1.522,3.909v.29a4.612,4.612,0,0,0,0,.616,5.5,5.5,0,0,0,.913,3.278s.793,4.348,2.025,5.452A4.908,4.908,0,0,1,708.3,707.8s1.494,6.309,2.2,7.414c.595.935.623,3.5.616,4.248h0v.234s.205,2.252.2,4.149v.658a6.6,6.6,0,0,1-.184,1.529V725.8a15.762,15.762,0,0,0-.453,3.93c-.042,2.266.3,4.957,1.678,6.521,2.379,2.726,3.873,2.386,3.873,2.386s-1.147,3.406-2.556,4.093a.85.85,0,0,0-.149.092.4.4,0,0,0-.035-.2,1.664,1.664,0,0,0-.411,1.275,9.121,9.121,0,0,0,1.742,5.049,2.79,2.79,0,0,0,1.19.708l-.22.135a4.944,4.944,0,0,1-.489.234,2.3,2.3,0,0,1-.708.184,3.357,3.357,0,0,0-2.493,1.211c-.878,1.133-1.416,2.684.3,4.043l6.295,2.167S729.4,759.074,728.852,756.61Z",
    transform: "translate(-216.509 -236.745)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4362",
    "data-name": "Path 4362",
    d: "M708.865,843.276l-6.1-2.167c-1.678-1.359-1.14-2.91-.29-4.043a3.208,3.208,0,0,1,2.407-1.211,2.981,2.981,0,0,0,1.168-.418,2.761,2.761,0,0,0,.963-.878,4.483,4.483,0,0,0,.708-2.358s6.691-1.954,8.5,0a5,5,0,0,1,.814,1.19,9.913,9.913,0,0,1,.85,4.312s.34,2.124.892,4.553S708.865,843.276,708.865,843.276Z",
    transform: "translate(-237.873 -319.389)",
    fill: "#2d293d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4363",
    "data-name": "Path 4363",
    d: "M750.975,839.075l-6.089-2.167c-1.685-1.359-1.147-2.91-.3-4.036A3.2,3.2,0,0,1,747,831.654a2.2,2.2,0,0,0,.708-.184,3.58,3.58,0,0,0,.467-.234A3.854,3.854,0,0,0,749.842,828s6.684-1.961,8.5,0a4.738,4.738,0,0,1,.637.871A9.729,9.729,0,0,1,760,833.5s.34,2.124.892,4.553S750.975,839.075,750.975,839.075Z",
    transform: "translate(-250.167 -318.161)",
    fill: "#2d293d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4364",
    "data-name": "Path 4364",
    d: "M718.432,832.2a5,5,0,0,1,.814,1.19h0l-10.026,1.161a4.483,4.483,0,0,0,.708-2.358S716.605,830.247,718.432,832.2Z",
    transform: "translate(-240.077 -319.388)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4365",
    "data-name": "Path 4365",
    d: "M760.6,828.826V830.7c-1.558,2.57-9.1,2.011-11.287.708a3.609,3.609,0,0,0,.467-.234,3.854,3.854,0,0,0,1.664-3.236s6.684-1.961,8.5,0A4.735,4.735,0,0,1,760.6,828.826Z",
    transform: "translate(-251.78 -318.144)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4366",
    "data-name": "Path 4366",
    d: "M745.942,777.075a16.713,16.713,0,0,0-1.2,2.556v6.734c-1.7,2.832-10.564,1.876-11.754.34s-2.471-5.537-1.112-6.217,2.471-4.093,2.471-4.093-1.416.34-3.746-2.386-1.614-8.773-1.19-10.225,0-6.3,0-6.3.085-3.406-.595-4.518-2.124-7.413-2.124-7.413a5.032,5.032,0,0,0-1.19-3.236c-1.19-1.112-1.961-5.452-1.961-5.452a5.587,5.587,0,0,1-.85-3.661c.255-2.124-1.452-4.433-1.452-4.433l-2.9-9.205-2.726-6.9-1.529,4s-.432,9.375-.085,11.329.85,7.152.85,7.152-1.706,3.413-.935,6.309.51,9.113.51,9.113.765,12.866.085,13.892-.595,3.54-.595,3.54,3.491,7.5,2.379,8.5-.765,3.838-.765,3.838,2.386,0,1.367,1.02-1.791,6.373-1.791,6.373l-10.317,1.3a21.811,21.811,0,0,1-2.308-4.348c-1.359-3.151.255-2.832,1.629-3.151s.5-1.19-1.119-2.216-.708-3.321-.708-3.321,2.471-4.178,1.621-4.518-.942-6.217-.942-6.217-1.7-6.989-1.275-8.858-1.367-6.373-1.367-6.373l-.595-5.367a14.756,14.756,0,0,1-1.841-10.154v-8.292s-2.386-16.017-2.733-24.075c-.212-5.183-.156-12.257-.085-16.675.043-2.471.085-4.114.085-4.114l36.82-3.831a30.51,30.51,0,0,0,.673,5.466c.375,2.018.963,4.638,1.884,7.909a35.971,35.971,0,0,1,1.027,16.357l-.34,11.839s3.236,7.923,2.556,10.621a22.486,22.486,0,0,0-.708,4.956s7.244,17.3,6.479,22.326,2.393,12.915,2.393,12.915S746.791,775.574,745.942,777.075Z",
    transform: "translate(-235.928 -274.487)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4367",
    "data-name": "Path 4367",
    d: "M737.22,754.824l11.173-1.494S742.077,759.8,737.22,754.824Z",
    transform: "translate(-248.25 -296.618)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4368",
    "data-name": "Path 4368",
    d: "M749.909,737.87s.389,3.958-2.039,5.452C747.87,743.322,752.211,742.642,749.909,737.87Z",
    transform: "translate(-251.359 -292.104)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4369",
    "data-name": "Path 4369",
    d: "M744.333,720.06s-9.361,7.711-12.745,7.081S744.333,720.06,744.333,720.06Z",
    transform: "translate(-246.47 -286.905)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4370",
    "data-name": "Path 4370",
    d: "M714.579,760.55s-7.081,1.621-7.322,4.475S714.579,760.55,714.579,760.55Z",
    transform: "translate(-239.502 -298.725)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4371",
    "data-name": "Path 4371",
    d: "M716.634,810.72s-10.047,1.876-7.194,3.158a48.711,48.711,0,0,0,7.541,2.294S720.216,816.342,716.634,810.72Z",
    transform: "translate(-239.992 -313.371)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(459.044 406.545)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4372",
    "data-name": "Path 4372",
    d: "M706.249,817.4a1.99,1.99,0,0,1-.921-1.459l-.1.184s-.942,2.294.708,3.321c.184.113.361.234.524.347.3-.057.623-.1.927-.177C708.735,819.3,707.871,818.447,706.249,817.4Z",
    transform: "translate(-697.877 -721.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4373",
    "data-name": "Path 4373",
    d: "M724.873,816.356c.276-.255.262-.913.1-1.756a4.751,4.751,0,0,0-.573,2.471,1.89,1.89,0,0,1,.474-.715Z",
    transform: "translate(-703.55 -721.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4374",
    "data-name": "Path 4374",
    d: "M722.588,757.22a11.726,11.726,0,0,0-.708,3.13,12.377,12.377,0,0,1,.779-2.124A6.326,6.326,0,0,0,722.588,757.22Z",
    transform: "translate(-702.816 -704.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4375",
    "data-name": "Path 4375",
    d: "M755.314,750.515a4.049,4.049,0,0,0,.092-.935c-.127.637-.212,1.232-.276,1.749C755.187,751.06,755.243,750.791,755.314,750.515Z",
    transform: "translate(-712.522 -702.068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4376",
    "data-name": "Path 4376",
    d: "M722.444,799.221a5.361,5.361,0,0,0,.255-1.891,6.24,6.24,0,0,0-.488,2.386,2.288,2.288,0,0,1,.234-.5Z",
    transform: "translate(-702.912 -716.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4377",
    "data-name": "Path 4377",
    d: "M719.486,822.68a34.084,34.084,0,0,0-1.168,5.233l-10.3,1.2a21.342,21.342,0,0,1-2.308-4.348,7.565,7.565,0,0,1-.29-.751c-.616.283-.864.92-.05,2.832a21.088,21.088,0,0,0,2.308,4.341l10.3-1.2s.772-5.367,1.792-6.373C720.265,823.07,719.946,822.815,719.486,822.68Z",
    transform: "translate(-697.844 -723.408)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4378",
    "data-name": "Path 4378",
    d: "M702.988,766.451s.085,5.884.935,6.224h0c.432-.97.708-1.891.333-2.046-.85-.34-.935-6.217-.935-6.217s-1.706-6.989-1.274-8.865-1.367-6.373-1.367-6.373l-.595-5.367a14.784,14.784,0,0,1-1.876-10.14v-8.277s-2.386-16.017-2.726-24.11c-.219-5.183-.156-12.257-.085-16.675V682.48h-.29s-.042,1.636-.085,4.114c-.071,4.411-.135,11.492.085,16.675.34,8.093,2.726,24.11,2.726,24.11v8.263a14.735,14.735,0,0,0,1.919,10.225l.595,5.367s1.792,4.51,1.359,6.373S702.988,766.451,702.988,766.451Z",
    transform: "translate(-694.956 -682.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4379",
    "data-name": "Path 4379",
    d: "M748.292,826.84a9.911,9.911,0,0,1-1.629-4.05c-1.055.949.156,4.638,1.289,6.1s10.055,2.471,11.761-.347v-1.621C757.4,829.205,749.424,828.292,748.292,826.84Z",
    transform: "translate(-709.932 -723.44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4380",
    "data-name": "Path 4380",
    d: "M766.93,814.878a17.028,17.028,0,0,0-1.19,2.556v1.2c.191-.439.467-1.02.85-1.706a5.16,5.16,0,0,0,.375-2.124Z",
    transform: "translate(-715.62 -721.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4381",
    "data-name": "Path 4381",
    d: "M747.86,811.619a16.4,16.4,0,0,0,.842-2.025s-1.416.34-3.753-2.386c-1.671-1.983-1.763-5.728-1.529-8.178-.425,1.452-1.112,7.5,1.19,10.225C746.118,811.046,747.244,811.506,747.86,811.619Z",
    transform: "translate(-708.977 -716.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4382",
    "data-name": "Path 4382",
    d: "M737.4,770.825a46.817,46.817,0,0,1,.17,5.049c.057-.333.12-.6.17-.793.432-1.416,0-6.3,0-6.3s.085-3.413-.595-4.518-2.124-7.414-2.124-7.414a5.032,5.032,0,0,0-1.19-3.236c-1.19-1.112-1.961-5.452-1.961-5.452a5.587,5.587,0,0,1-.857-3.661c.262-2.124-1.416-4.433-1.416-4.433l-2.9-9.205L723.936,724l-1.536,4s0,.5-.05,1.3l1.246-3.25,2.726,6.9,2.9,9.205s1.7,2.3,1.416,4.426a5.6,5.6,0,0,0,.885,3.625s.765,4.341,1.954,5.452a5.057,5.057,0,0,1,1.2,3.236s1.416,6.3,2.124,7.414S737.4,770.825,737.4,770.825Z",
    transform: "translate(-702.953 -694.601)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4383",
    "data-name": "Path 4383",
    d: "M750.243,565.468l-.637,3.116.035,1.416v1.02l-3.54.368-.4-.708h0a30.13,30.13,0,0,0-2.762-4.461c-.658-.552-1.827-9.2-.425-8.688a3.71,3.71,0,0,1,1.983,1.791S751.5,560.059,750.243,565.468Z",
    transform: "translate(-249.604 -239.452)",
    fill: "#ffcdd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4384",
    "data-name": "Path 4384",
    d: "M751.267,575.96l-3.54.368-.4-.708h0a3.13,3.13,0,0,1,3.923-.644Z",
    transform: "translate(-251.202 -244.428)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4385",
    "data-name": "Path 4385",
    d: "M752.069,577.773l-4.68,1.09-.1-.708-.269-1.876a3.222,3.222,0,0,1,4.539-.623l.234.956Z",
    transform: "translate(-251.111 -244.555)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4386",
    "data-name": "Path 4386",
    d: "M642.231,563.069l-5,2.691-.453-.949c-.482-1-1.19-2.5-1.416-3.038-.3-.828-2.386-1.876-2.386-1.876-5.24-5.006,1-9.3,1-9.3,3.307-6.649,6.989,2.252,6.989,2.252s.51,4.695.149,5.006-.361,1.6-.361,1.6a19.46,19.46,0,0,1,1.211,2.832C642.153,562.779,642.231,563.069,642.231,563.069Z",
    transform: "translate(-217.207 -236.713)",
    fill: "#ffcdd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4387",
    "data-name": "Path 4387",
    d: "M644.662,568.9l-5,2.691-.453-.949c.708-.588,3.208-2.62,4.029-2.528a5.87,5.87,0,0,0,1.19,0C644.584,568.614,644.662,568.9,644.662,568.9Z",
    transform: "translate(-219.639 -242.549)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4388",
    "data-name": "Path 4388",
    d: "M645.233,570.56l-5.622,2.768-.113-1.211-.078-.828s3.257-2.8,4.248-2.691a5.232,5.232,0,0,0,1.473,0l.064,1.013Z",
    transform: "translate(-219.7 -242.689)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4389",
    "data-name": "Path 4389",
    d: "M725.994,590.094s-24.521,2.768-19.939,1.282c3.193-1.041,4.461-3.066,4.73-5.318a12.95,12.95,0,0,0-.913-5.665,24.625,24.625,0,0,0-2.195-4.432s18.743-10.31,15-.935a14.691,14.691,0,0,0-1.062,4.44,12.521,12.521,0,0,0,.474,4.489A13.39,13.39,0,0,0,725.994,590.094Z",
    transform: "translate(-238.986 -243.417)",
    fill: "#ffcdd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4390",
    "data-name": "Path 4390",
    d: "M723.577,575.02a14.7,14.7,0,0,0-1.062,4.44c-1.77,1.48-3.7,1.416-6.189,1.416-1.912,0-4.029.467-5.551-.453a24.619,24.619,0,0,0-2.195-4.432S727.323,565.645,723.577,575.02Z",
    transform: "translate(-239.89 -243.417)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 10.14,
    cy: 10.14,
    r: 10.14,
    transform: "translate(465.964 317.802)",
    fill: "#ffcdd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4391",
    "data-name": "Path 4391",
    d: "M725.994,594.962s-24.521,2.769-19.939,1.282c3.193-1.041,4.461-3.066,4.73-5.318,1.218-1.324,3.668-2.28,5.247-2.783a7.315,7.315,0,0,1,4.44-.071,5.919,5.919,0,0,1,1.614.708A13.39,13.39,0,0,0,725.994,594.962Z",
    transform: "translate(-238.986 -248.284)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4392",
    "data-name": "Path 4392",
    d: "M752.18,578.373l-4.68,1.09-.1-.708a4.135,4.135,0,0,1,4.5-1.544Z",
    transform: "translate(-251.222 -245.156)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(364.381 387.126) rotate(-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_734",
    "data-name": "Rectangle 734",
    width: 191.23,
    height: 2.039,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_735",
    "data-name": "Rectangle 735",
    width: 191.23,
    height: 2.039,
    transform: "translate(0 4.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_736",
    "data-name": "Rectangle 736",
    width: 191.23,
    height: 2.039,
    transform: "translate(0 9.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4393",
    "data-name": "Path 4393",
    d: "M645.265,570.979l-5.622,2.769-.113-1.211a41.376,41.376,0,0,1,5.665-2.506Z",
    transform: "translate(-219.732 -243.108)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4394",
    "data-name": "Path 4394",
    d: "M732.663,682.936c-9.5,1.494-23.012,3.448-25.158,2.8-1.777-.545-7.456-.489-12.406-.319.043-2.471.085-4.114.085-4.114L732,677.47a30.5,30.5,0,0,0,.658,5.466Z",
    transform: "translate(-235.954 -274.472)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4395",
    "data-name": "Path 4395",
    d: "M725.3,649.436s-31.269,5.367-34.625,4.341-20.584.092-20.584.092c-7.754,5.19-4.51-2.471-4.51-2.471a18.476,18.476,0,0,1,.255-7.244,44.356,44.356,0,0,0,1.275-7.244s-.17-5.112.765-6.3,2.046-9.715,2.046-9.715.857-5.792.772-7.081.255-4.85.255-4.85l1.1-5.969c-6.373-.85-25.816-12.781-25.816-12.781-.935-4-8.178-13.376-8.178-13.376a9.86,9.86,0,0,0-.595-2.3c-.51-1.359,7.159-4.086,7.159-4.086s5.707,6.989,6.9,8.858,5.282,5.367,5.282,5.367a4.129,4.129,0,0,1,1.876.248h.1a15.113,15.113,0,0,1,3.809,2.188,7.386,7.386,0,0,1,5.2,1.961s3.5-.51,4.093.085,3.54,0,3.54,0,2.988-6.3,4.957-4.475,10.274,1.749,10.274,1.749c1.112-1.473,3.8-2.528,5.495-3.073a7.315,7.315,0,0,1,4.44-.071,5.5,5.5,0,0,1,1.756.85l5.041,4.957s1.416-1.876,1.282-2.3,1.706-.765,1.706-.765,2.471-.765,3.406-1.027,1.8.765,1.869.85a9.974,9.974,0,0,1-.425-3.746,4.249,4.249,0,0,0-1.02-3.066c3.009-7.279,9.743-1.119,9.743-1.119s.765,4,.085,5.537.708,4.772.51,5.622.34,2.3.34,3.916a23.294,23.294,0,0,1-1.359,6.054c-.517,1.359-4.6,4.425-4.6,4.425s-.255,4.857-2.046,7.668-.708,12.441-.708,12.441,1.7,7.5,3.831,9.913S725.3,649.436,725.3,649.436Z",
    transform: "translate(-219.121 -243.23)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4396",
    "data-name": "Path 4396",
    d: "M695.393,600.716s-.935-2.832-1.792-3.073a20.168,20.168,0,0,1-2.471-1.1l.552-1.048s3.2.878,3.71,1.813S695.393,600.716,695.393,600.716Z",
    transform: "translate(-234.795 -250.54)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    "data-name": "Path 4397",
    d: "M669.806,593.163c-.17.857-7.746,1.621-7.746,1.621l3.831-3.845h0l.1.035h0a15.109,15.109,0,0,1,3.817,2.188Z",
    transform: "translate(-226.309 -249.212)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 0.68,
    cy: 0.68,
    r: 0.68,
    transform: "translate(420.853 331.582)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 0.68,
    cy: 0.68,
    r: 0.68,
    transform: "translate(421.724 332.948)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171",
    "data-name": "Ellipse 171",
    cx: 0.68,
    cy: 0.68,
    r: 0.68,
    transform: "translate(422.581 334.201)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 0.68,
    cy: 0.68,
    r: 0.68,
    transform: "translate(423.473 335.568)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 0.552,
    cy: 0.552,
    r: 0.552,
    transform: "translate(503.91 335.618)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 0.552,
    cy: 0.552,
    r: 0.552,
    transform: "translate(503.995 336.878)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 0.552,
    cy: 0.552,
    r: 0.552,
    transform: "translate(504.066 338.131)",
    fill: "#575988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4398",
    "data-name": "Path 4398",
    d: "M697.21,635.47c-.078-.1,19.118,24.152,34.037,10.14C731.247,645.609,707.682,648.8,697.21,635.47Z",
    transform: "translate(-236.57 -262.211)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4399",
    "data-name": "Path 4399",
    d: "M681.63,653.28s11.492.312,12.7,3.618v3.441a2.2,2.2,0,0,1-2.124,0c-1.161-.623-8.108-4.156-10.557-2.457Z",
    transform: "translate(-232.022 -267.41)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4400",
    "data-name": "Path 4400",
    d: "M681.93,653.28s10.989.3,12.143,3.448v3.286a2.124,2.124,0,0,1-2.046,0c-1.112-.6-7.789-3.965-10.1-2.344Z",
    transform: "translate(-232.11 -267.41)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4401",
    "data-name": "Path 4401",
    d: "M690.49,618a37.013,37.013,0,0,0,4.454,7.64,29.844,29.844,0,0,0,6.982,6.741S690.681,619.607,690.49,618Z",
    transform: "translate(-234.609 -257.111)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4402",
    "data-name": "Path 4402",
    d: "M685.18,599.18s1.919,8.277,6.854,11.088Z",
    transform: "translate(-233.058 -251.617)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4403",
    "data-name": "Path 4403",
    d: "M680.929,600.359c-.05-.156-1.706,6.543,6.373,10.253C687.3,610.612,683.889,609.451,680.929,600.359Z",
    transform: "translate(-231.767 -251.961)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4404",
    "data-name": "Path 4404",
    d: "M751.9,592.518c-.128,0,3.979,2.62,5.1,3.831C757,596.349,754.327,592.348,751.9,592.518Z",
    transform: "translate(-252.535 -249.671)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4405",
    "data-name": "Path 4405",
    d: "M711.7,575a2.159,2.159,0,0,0,.786,1.374,2.215,2.215,0,0,0,.956.212c3.094.191,6.309.326,9.205-.864a3.426,3.426,0,0,0,1.416-.928,5.517,5.517,0,0,0,.751-2.23,34.762,34.762,0,0,1,1.876-4.305,14.465,14.465,0,0,0,1-7.732,5.177,5.177,0,0,0-.772-2.266c-.821-1.168-2.315-1.643-3.4-2.577s-1.784-2.358-3.045-3.059a5.92,5.92,0,0,0-3.824-.34,20.2,20.2,0,0,0-7.137,2.684,3.534,3.534,0,0,1-2.386.814,3.279,3.279,0,0,1-1.756-1.345,9.431,9.431,0,0,0-.758,4.411,1.306,1.306,0,0,1-.474,1.374c-.765.885-1.239,2.287-.489,3.179.333.389.836.6,1.154,1,.574.708.375,1.735.361,2.648a1.417,1.417,0,0,0,.227.9,1.317,1.317,0,0,0,1.253.3,3.427,3.427,0,0,1,1.331-.128,2.245,2.245,0,0,1,1.161.892A16.189,16.189,0,0,1,711.7,575Z",
    transform: "translate(-238.341 -237.878)",
    fill: "#2d293d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(464.864 322.702)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4406",
    "data-name": "Path 4406",
    d: "M724.294,577.509a3.349,3.349,0,0,1-1.416.92c-2.832,1.2-6.075,1.055-9.162.864a2.08,2.08,0,0,1-.956-.212,2.124,2.124,0,0,1-.793-1.367,15.8,15.8,0,0,0-2.584-6,2.21,2.21,0,0,0-1.161-.892,3.428,3.428,0,0,0-1.331.128,1.317,1.317,0,0,1-1.253-.3,1.373,1.373,0,0,1-.22-.9c0-.913.205-1.94-.368-2.648-.319-.4-.821-.609-1.154-1a2,2,0,0,1-.191-2.039,2.332,2.332,0,0,0-.149,2.719c.333.389.836.6,1.154,1,.573.708.375,1.735.361,2.648a1.416,1.416,0,0,0,.227.9,1.31,1.31,0,0,0,1.253.3,3.427,3.427,0,0,1,1.331-.127,2.245,2.245,0,0,1,1.161.892,16.079,16.079,0,0,1,2.584,6,2.16,2.16,0,0,0,.786,1.374,2.215,2.215,0,0,0,.956.212c3.094.191,6.309.326,9.205-.864a3.474,3.474,0,0,0,1.416-.927,2.7,2.7,0,0,0,.439-.821A.51.51,0,0,1,724.294,577.509Z",
    transform: "translate(-703.176 -564.07)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4407",
    "data-name": "Path 4407",
    d: "M712.62,593.027s12.667,1.678,13.807-.227",
    transform: "translate(-241.069 -249.755)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4408",
    "data-name": "Path 4408",
    d: "M747.4,585.72s7.031,0,8.582,2.648",
    transform: "translate(-251.222 -247.688)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_729",
    "data-name": "Rectangle 729",
    width: 39.075,
    height: 2.039,
    transform: "translate(152.538 403.529)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_730",
    "data-name": "Rectangle 730",
    width: 39.075,
    height: 2.039,
    transform: "translate(152.538 408.492)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 3.524,
    cy: 3.524,
    r: 3.524,
    transform: "translate(153.86 417.787)",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 3.524,
    cy: 3.524,
    r: 3.524,
    transform: "translate(153.86 427.803)",
    fill: "#747474"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilder);
export default __webpack_public_path__ + "static/media/builder.3cfea7ca678cb9902e520d0a7f40cc47.svg";
export { ForwardRef as ReactComponent };